  (function () {
    var SUPABASE_URL = "https://vjjpmtbrcftxfbbwquvg.supabase.co";
    var SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqanBtdGJyY2Z0eGZiYndxdXZnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE0NzU0NDksImV4cCI6MjA5NzA1MTQ0OX0.tHdjBPGmApEvrAtem9btSzh0MtAnTbPH3Db5MAM0d9E";
    var STUDY_LOUNGE_URL = window.location.origin + "/study-lounge";
    var AGE_BAND_STORAGE_KEY = "memoryfuelStudyAgeBandV1";
    var AGE_BAND_13_PLUS = "13_plus";
    var AGE_BAND_UNDER_13 = "under_13";
    var SHOPIFY_BRIDGE_URL = "/apps/memory-fuel-study-auth";
    var ageBand = readAgeBand();
    var MF_BLOCKED_CHAT_WORDS = [
      "arse",
      "arsehole",
      "ass",
      "asshat",
      "asshole",
      "bastard",
      "bitch",
      "bollocks",
      "bullshit",
      "cabron",
      "caonima",
      "caralho",
      "cazzo",
      "chutiya",
      "clit",
      "cock",
      "coglione",
      "connard",
      "cono",
      "crap",
      "cunt",
      "damn",
      "dick",
      "dickhead",
      "douche",
      "douchebag",
      "encule",
      "enfoire",
      "fag",
      "faggot",
      "filho da puta",
      "fuck",
      "fucker",
      "fucking",
      "gaesaekki",
      "goddamn",
      "hijo de puta",
      "hoe",
      "hurensohn",
      "ibn kalb",
      "jackass",
      "jerkoff",
      "joder",
      "kike",
      "khara",
      "kuso",
      "madarchod",
      "maricon",
      "merda",
      "merde",
      "mierda",
      "mf",
      "motherfucker",
      "nazi",
      "negro",
      "nigga",
      "nigger",
      "pendejo",
      "piss",
      "pizda",
      "porn",
      "porno",
      "porra",
      "prick",
      "puta",
      "putain",
      "puto",
      "puttana",
      "pussy",
      "retard",
      "salope",
      "scheisse",
      "sex",
      "sexo",
      "shabi",
      "sharmouta",
      "slut",
      "ssibal",
      "spic",
      "shit",
      "shitty",
      "skank",
      "stronzo",
      "suka",
      "tard",
      "twat",
      "vaffanculo",
      "verga",
      "whore",
      "wichser",
      "wop"
    ];

    setupBackgroundArtwork();
    setupVideoMode();
    setupQuickMenu();
    setupYearCountdown();
    setupStreakPreview();
    window.addEventListener("mf:daily-quotes-ready", renderDailyQuote);
    renderDailyQuote();

    function setupStreakPreview() {
      if (new URLSearchParams(window.location.search).get("mf_streak_preview") !== "1") return;
      var colors = ["#ffc400", "#ff8a32", "#f0065f", "#3f9fff", "#a55cff", "#090a0d", "#ffd86a"];
      var names = ["Yellow", "Orange", "Red", "Blue", "Purple", "Black", "Gold"];
      var gradients = [
        "linear-gradient(90deg,#ffc400,#ffc400)",
        "linear-gradient(90deg,#ffc400 0%,#ff8a32 100%)",
        "linear-gradient(90deg,#ffc400 0%,#ff8a32 48%,#f0065f 100%)",
        "linear-gradient(90deg,#ffc400 0%,#ff8a32 31%,#f0065f 62%,#3f9fff 100%)",
        "linear-gradient(90deg,#ffc400 0%,#ff8a32 25%,#f0065f 49%,#3f9fff 74%,#a55cff 100%)",
        "linear-gradient(90deg,#ffc400 0%,#ff8a32 20%,#f0065f 40%,#3f9fff 60%,#a55cff 80%,#0a0b0e 100%)",
        "linear-gradient(90deg,#ffc400 0%,#ff8a32 14%,#f0065f 28%,#3f9fff 42%,#a55cff 56%,#0a0b0e 70%,#9b6b08 79%,#ffd700 90%,#fff1a6 96%,#c99712 100%)"
      ];
      var weekdays = ["M", "T", "W", "T", "F", "S", "S"];
      var overlay = document.createElement("div");
      overlay.className = "mf-streak-preview-overlay";
      overlay.setAttribute("role", "dialog");
      overlay.setAttribute("aria-modal", "true");
      overlay.setAttribute("aria-labelledby", "mf-streak-preview-title");
      overlay.innerHTML = '<div class="mf-streak-preview-shell"><header class="mf-streak-preview-header"><div><p>Memory Fuel · Implemented Preview</p><h2 id="mf-streak-preview-title">All 7 Study Streak Levels</h2><span>This does not change your real Study Lounge streak.</span></div><button type="button" class="mf-streak-preview-close" aria-label="Close streak preview">×</button></header><div class="mf-streak-preview-grid"></div></div>';
      var grid = overlay.querySelector(".mf-streak-preview-grid");
      gradients.forEach(function (gradient, index) {
        var day = index + 1;
        var card = document.createElement("article");
        card.className = "mf-streak-preview-card level-" + day + (day === 7 ? " is-complete" : "");
        card.style.setProperty("--mf-preview-gradient", gradient);
        card.style.setProperty("--mf-preview-width", ((day / 7) * 100).toFixed(3) + "%");
        card.style.setProperty("--mf-preview-glow", colors[index] + "77");
        card.style.setProperty("--mf-preview-accent", day === 7 ? "#ffd700" : (day === 6 ? "#d9d8df" : colors[index]));
        card.style.setProperty("--mf-preview-flame-color", day === 6 ? "#07080b" : (day === 7 ? "#ffd700" : colors[index]));
        card.style.setProperty("--mf-preview-flame-size", (15 + day * 2) + "px");
        var stamps = weekdays.map(function (weekday, stampIndex) {
          var active = stampIndex < day;
          var stampStyle = active ? ' style="--mf-preview-stamp:' + colors[stampIndex] + ';--mf-preview-stamp-glow:' + colors[stampIndex] + '88"' : "";
          return '<span class="mf-streak-preview-stamp' + (active ? " is-earned level-" + (stampIndex + 1) : "") + '"><i' + stampStyle + '></i><small>' + weekday + '</small></span>';
        }).join("");
        card.innerHTML = '<div class="mf-streak-preview-card-head"><div><small>Level ' + day + '</small><h3>Study Streak</h3><p>You have studied ' + day + ' day' + (day === 1 ? "" : "s") + ' in a row.</p></div><strong><span class="mf-streak-preview-flame" aria-hidden="true"></span>' + day + ' day' + (day === 1 ? "" : "s") + '</strong></div><div class="mf-streak-preview-track"><i></i></div><div class="mf-streak-preview-stamps">' + stamps + '</div><footer>Earned: ' + names.slice(0, day).join(" → ") + '</footer>';
        grid.appendChild(card);
      });
      document.body.appendChild(overlay);
      document.body.classList.add("mf-streak-preview-open");
      var close = overlay.querySelector(".mf-streak-preview-close");
      close.addEventListener("click", function () {
        overlay.remove();
        document.body.classList.remove("mf-streak-preview-open");
      });
      close.focus();
    }

    if (!window.supabase || SUPABASE_URL.indexOf("PASTE_") === 0 || SUPABASE_ANON_KEY.indexOf("PASTE_") === 0) {
      document.getElementById("mf-auth-message").textContent = "Add your Supabase URL and anon key inside this code block.";
      return;
    }

    function setupQuickMenu() {
      var lounge = document.querySelector(".mf-study-lounge");
      var toggle = document.getElementById("mf-quick-menu-toggle");
      var panel = document.getElementById("mf-quick-menu-panel");
      var quickView = document.getElementById("mf-quick-view");
      var quickContent = document.getElementById("mf-quick-view-content");
      var quickTitle = document.getElementById("mf-quick-view-title");
      var flashcardStudio = document.getElementById("mf-flashcard-studio");
      var flashcardClose = document.getElementById("mf-flashcard-studio-close");
      var menuWrap = toggle ? toggle.closest(".mf-quick-menu-wrap") : null;
      var homeButton = panel ? panel.querySelector("[data-mf-quick-home]") : null;
      var toolButtons = panel ? Array.prototype.slice.call(panel.querySelectorAll("[data-mf-quick-view]")) : [];
      var actionButtons = panel ? Array.prototype.slice.call(panel.querySelectorAll("[data-mf-quick-action]")) : [];
      var menuItems = panel ? Array.prototype.slice.call(panel.querySelectorAll(":scope > button, :scope > a")) : [];
      var menuRailPath = panel ? panel.querySelector(".mf-quick-menu-rail path") : null;
      var tools = {
        calendar: { selector: ".mf-study-chart", title: "Study Calendar" },
        timer: { selector: "#mf-timer-widget", title: "Focus Timer" },
        todo: { selector: ".mf-checklist", title: "To-Do List" },
        leaderboard: { selector: ".mf-leaderboard", title: "Leaderboard" }
      };
      var activeTool = null;
      var activeKey = "";
      var placeholder = null;

      if (!lounge || !toggle || !panel || !quickView || !quickContent || !menuWrap || !homeButton) return;
      document.body.appendChild(menuWrap);
      document.body.appendChild(panel);

      function positionMenuUnderCart() {
        var cart = document.querySelector('#header-component button[aria-label*="Cart" i], #header-group button[aria-label*="Cart" i], button[aria-label="Cart"]');
        if (!cart) return;
        var cartRect = cart.getBoundingClientRect();
        var menuWidth = toggle.getBoundingClientRect().width || 54;
        var alignedRight = Math.max(0, window.innerWidth - (cartRect.left + cartRect.width / 2) - menuWidth / 2);
        menuWrap.style.right = alignedRight.toFixed(2) + "px";
        panel.style.right = alignedRight.toFixed(2) + "px";
      }

      positionMenuUnderCart();
      window.requestAnimationFrame(positionMenuUnderCart);
      window.setTimeout(positionMenuUnderCart, 600);
      window.addEventListener("resize", positionMenuUnderCart);

      function updateCurrentMenuItem() {
        menuItems.forEach(function (item) {
          var itemKey = item.getAttribute("data-mf-quick-view") || item.getAttribute("data-mf-quick-action") || (item.hasAttribute("data-mf-quick-home") ? "home" : "");
          var current = itemKey === (activeKey || "home");
          item.classList.toggle("is-current", current);
          if (current) item.setAttribute("aria-current", "page");
          else item.removeAttribute("aria-current");
        });
      }

      function animateMenuOpen() {
        var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        updateCurrentMenuItem();
        if (reduceMotion || !window.Motion || typeof window.Motion.animate !== "function") return;
        var animate = window.Motion.animate;
        var menuAnimation = animate(panel, {
          opacity: [0, 1],
          transform: ["translate3d(10px, -4px, 0) scale(.985)", "translate3d(0, 0, 0) scale(1)"]
        }, {
          duration: .16,
          ease: [.22, 1, .36, 1]
        });
        if (menuAnimation && typeof menuAnimation.then === "function") {
          menuAnimation.then(function () {
            panel.style.removeProperty("opacity");
            panel.style.removeProperty("transform");
          });
        }
        if (menuRailPath) animate(menuRailPath, { opacity: [.5, 1] }, { duration: .16, ease: "easeOut" });
      }

      function setMenu(open) {
        panel.hidden = !open;
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        document.documentElement.classList.toggle("mf-quick-menu-active", open);
        if (open) {
          window.requestAnimationFrame(animateMenuOpen);
          window.setTimeout(function () {
            var first = panel.querySelector("button, a");
            if (first) first.focus();
          }, 0);
        }
      }

      function restoreTool() {
        if (activeTool && placeholder && placeholder.parentNode) {
          placeholder.parentNode.insertBefore(activeTool, placeholder);
          placeholder.remove();
        }
        if (activeTool) activeTool.classList.remove("mf-is-quick-view-tool");
        activeTool = null;
        activeKey = "";
        placeholder = null;
        quickContent.textContent = "";
      }

      function closeQuickView(options) {
        options = options || {};
        if (quickView.hidden) return;
        var closedKey = activeKey;
        setMenu(false);
        restoreTool();
        quickView.hidden = true;
        lounge.classList.remove("mf-quick-view-open");
        document.documentElement.classList.remove("mf-quick-view-lock");
        if (options.focus !== false) toggle.focus();
        if (options.pageTop) window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        window.dispatchEvent(new CustomEvent("mf:quick-view-close", { detail: { tool: closedKey } }));
      }

      function closeFlashcardsIfOpen() {
        if (!flashcardStudio || flashcardStudio.hidden) return;
        if (window.MemoryFuelFlashcards && typeof window.MemoryFuelFlashcards.close === "function") {
          window.MemoryFuelFlashcards.close();
        } else if (flashcardClose) {
          flashcardClose.click();
        }
      }

      function needsAccount(button) {
        var key = button.getAttribute("data-mf-quick-view");
        var config = tools[key];
        var tool = config ? document.querySelector(config.selector) : null;
        var community = document.getElementById("mf-community-view");
        return Boolean(
          (button.hasAttribute("data-mf-requires-account") && community && community.hidden) ||
          (key === "timer" && tool && tool.hidden)
        );
      }

      function requestAccount() {
        setMenu(false);
        var accountPanel = document.getElementById("mf-account-panel");
        var accountToggle = document.getElementById("mf-account-toggle");
        if (accountPanel && accountToggle) {
          if (accountPanel.hidden) accountToggle.click();
          else accountToggle.focus();
        }
      }

      function openTool(key) {
        var config = tools[key];
        var tool = config ? document.querySelector(config.selector) : null;
        if (!config || !tool) return;
        closeFlashcardsIfOpen();
        if (activeTool) {
          var replacedKey = activeKey;
          restoreTool();
          window.dispatchEvent(new CustomEvent("mf:quick-view-close", { detail: { tool: replacedKey } }));
        }
        placeholder = document.createElement("span");
        placeholder.className = "mf-quick-view-placeholder";
        placeholder.hidden = true;
        tool.parentNode.insertBefore(placeholder, tool);
        activeTool = tool;
        activeKey = key;
        tool.classList.add("mf-is-quick-view-tool");
        quickTitle.textContent = config.title;
        quickContent.appendChild(tool);
        quickView.hidden = false;
        lounge.classList.add("mf-quick-view-open");
        document.documentElement.classList.add("mf-quick-view-lock");
        setMenu(false);
        window.setTimeout(function () { toggle.focus(); }, 0);
        window.dispatchEvent(new CustomEvent("mf:quick-view-open", { detail: { tool: activeKey } }));
      }

      toggle.addEventListener("click", function () { setMenu(panel.hidden); });
      homeButton.addEventListener("click", function () {
        setMenu(false);
        closeFlashcardsIfOpen();
        closeQuickView({ focus: false });
        window.requestAnimationFrame(function () {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        });
      });
      toolButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          if (needsAccount(button)) {
            requestAccount();
            return;
          }
          openTool(button.getAttribute("data-mf-quick-view"));
        });
      });
      actionButtons.forEach(function (button) {
        button.addEventListener("click", function () {
          setMenu(false);
          if (button.getAttribute("data-mf-quick-action") === "flashcards") {
            if (!quickView.hidden) closeQuickView({ focus: false });
            activeKey = "flashcards";
            window.dispatchEvent(new CustomEvent("memoryfuel:flashcards-open", { detail: { tab: "create" } }));
          }
        });
      });
      window.addEventListener("memoryfuel:flashcards-close", function () {
        if (activeKey === "flashcards") activeKey = "";
        setMenu(false);
      });
      document.addEventListener("click", function (event) {
        if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) setMenu(false);
      });
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        if (!quickView.hidden) closeQuickView();
        else if (!panel.hidden) { setMenu(false); toggle.focus(); }
      });
      window.addEventListener("memoryfuel:auth-state", function () {
        toolButtons.forEach(function (button) {
          var locked = needsAccount(button);
          button.classList.toggle("is-account-required", locked);
          button.setAttribute("aria-label", locked ? button.querySelector("strong").textContent + " — sign in required" : button.querySelector("strong").textContent);
        });
      });
    }

    function setupYearCountdown() {
      var widget = document.getElementById("mf-year-countdown");
      var yearLabel = document.getElementById("mf-countdown-year");
      var daysLabel = document.getElementById("mf-countdown-days");
      var hoursLabel = document.getElementById("mf-countdown-hours");
      var minutesLabel = document.getElementById("mf-countdown-minutes");
      var secondsLabel = document.getElementById("mf-countdown-seconds");
      var daysRing = document.getElementById("mf-countdown-days-ring");
      var hoursRing = document.getElementById("mf-countdown-hours-ring");
      var minutesRing = document.getElementById("mf-countdown-minutes-ring");
      var secondsRing = document.getElementById("mf-countdown-seconds-ring");
      var progressFill = document.getElementById("mf-countdown-progress-fill");
      var remainingLabel = document.getElementById("mf-countdown-remaining");
      var percentLabel = document.getElementById("mf-countdown-percent");
      if (!widget || !yearLabel || !daysLabel || !hoursLabel || !minutesLabel || !secondsLabel || !daysRing || !hoursRing || !minutesRing || !secondsRing || !progressFill || !remainingLabel || !percentLabel) return;

      function twoDigits(value) { return String(value).padStart(2, "0"); }
      var lastRenderedSecond = -1;

      function renderYearCountdown() {
        var now = new Date();
        var year = now.getFullYear();
        var yearStart = new Date(year, 0, 1);
        var nextYear = new Date(year + 1, 0, 1);
        var yearDuration = nextYear.getTime() - yearStart.getTime();
        var remaining = Math.max(0, nextYear.getTime() - now.getTime());
        var usedPercent = Math.min(100, Math.max(0, ((now.getTime() - yearStart.getTime()) / yearDuration) * 100));
        var totalSeconds = Math.floor(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (totalSeconds !== lastRenderedSecond) {
          lastRenderedSecond = totalSeconds;
          yearLabel.textContent = String(year);
          daysLabel.textContent = String(days);
          hoursLabel.textContent = twoDigits(hours);
          minutesLabel.textContent = twoDigits(minutes);
          secondsLabel.textContent = twoDigits(seconds);
          remainingLabel.textContent = days + (days === 1 ? " day" : " days") + " left in " + year;
          percentLabel.textContent = usedPercent.toFixed(1) + "% used";
          widget.setAttribute("aria-label", days + " days, " + hours + " hours, " + minutes + " minutes remaining in " + year);
        }
        daysRing.style.setProperty("--mf-ring-progress", usedPercent.toFixed(3) + "%");
        hoursRing.style.setProperty("--mf-ring-progress", (100 - ((remaining % 86400000) / 86400000) * 100).toFixed(4) + "%");
        minutesRing.style.setProperty("--mf-ring-progress", (100 - ((remaining % 3600000) / 3600000) * 100).toFixed(4) + "%");
        secondsRing.style.setProperty("--mf-ring-progress", (100 - ((remaining % 60000) / 60000) * 100).toFixed(4) + "%");
        widget.style.setProperty("--mf-year-progress", (usedPercent / 100).toFixed(6));
      }

      renderYearCountdown();
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        window.setInterval(renderYearCountdown, 1000);
      } else {
        var lastCountdownFrame = 0;
        (function animateYearCountdown(timestamp) {
          if (!lastCountdownFrame || timestamp - lastCountdownFrame >= 33) {
            lastCountdownFrame = timestamp;
            renderYearCountdown();
          }
          window.requestAnimationFrame(animateYearCountdown);
        })();
      }
    }

    function setupBackgroundArtwork() {
      var lounge = document.querySelector(".mf-study-lounge");
      var picker = document.querySelector(".mf-artwork-picker");
      var toggle = document.getElementById("mf-artwork-toggle");
      var panel = document.getElementById("mf-artwork-panel");
      var close = document.getElementById("mf-artwork-close");
      var options = panel ? Array.prototype.slice.call(panel.querySelectorAll(".mf-artwork-option")) : [];
      var timerWidget = document.getElementById("mf-timer-widget");
      var timerToggle = document.getElementById("mf-timer-artwork");
      var timerPanel = document.getElementById("mf-timer-artwork-panel");
      var timerClose = document.getElementById("mf-timer-artwork-close");
      var timerGrid = document.getElementById("mf-timer-artwork-grid");
      var artworkStage = document.getElementById("mf-artwork-stage");
      var artworkStageImage = document.getElementById("mf-artwork-stage-image");
      var timerArtworkStage = document.getElementById("mf-timer-artwork-stage");
      var timerArtworkStageImage = document.getElementById("mf-timer-artwork-stage-image");
      var timerOptions = [];
      var storageKey = "memoryfuelStudyArtworkV2";
      var artworkNaturalWidth = 0;
      var artworkNaturalHeight = 0;
      var artworkScaleOverrides = {};

      if (!lounge || !picker || !toggle || !panel || !close || !options.length) return;

      function loadArtworkThumbnail(image) {
        var source = image.getAttribute("data-src");
        if (!source) return;
        image.setAttribute("loading", "eager");
        image.src = source;
        image.removeAttribute("data-src");
      }

      function setupArtworkThumbnailLoading(container, viewport) {
        if (!container) return;
        var thumbnails = Array.prototype.slice.call(container.querySelectorAll("img[data-src]"));
        if (!thumbnails.length) return;

        if (!("IntersectionObserver" in window)) {
          thumbnails.forEach(loadArtworkThumbnail);
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadArtworkThumbnail(entry.target);
            observer.unobserve(entry.target);
          });
        }, {
          root: viewport || null,
          rootMargin: "160px 0px"
        });

        thumbnails.forEach(function (thumbnail) {
          observer.observe(thumbnail);
        });
      }

      function scheduleArtworkThumbnailPreload(container) {
        if (!container) return;
        var remaining = Array.prototype.slice.call(container.querySelectorAll("img[data-src]"));
        if (!remaining.length) return;

        function runWhenIdle(callback, timeout) {
          if ("requestIdleCallback" in window) {
            window.requestIdleCallback(callback, { timeout: timeout || 1400 });
          } else {
            window.setTimeout(callback, 500);
          }
        }

        function loadBatch(size) {
          remaining.splice(0, size).forEach(loadArtworkThumbnail);
        }

        function loadFinalBatches() {
          if (!remaining.length) return;
          if (document.documentElement.classList.contains("mf-quick-menu-active")) {
            window.setTimeout(loadFinalBatches, 500);
            return;
          }
          runWhenIdle(function () {
            loadBatch(3);
            if (remaining.length) window.setTimeout(loadFinalBatches, 900);
          }, 1600);
        }

        function beginPreload() {
          runWhenIdle(function () {
            loadBatch(10);
            if (remaining.length) window.setTimeout(loadFinalBatches, 900);
          }, 1400);
        }

        if (document.readyState === "complete") beginPreload();
        else window.addEventListener("load", beginPreload, { once: true });
      }

      function closePicker() {
        panel.hidden = true;
        toggle.setAttribute("aria-expanded", "false");
      }

      function closeTimerPicker() {
        if (!timerPanel || !timerToggle) return;
        timerPanel.hidden = true;
        timerToggle.setAttribute("aria-expanded", "false");
      }

      function openTimerPicker() {
        if (!timerPanel || !timerToggle) return;
        timerPanel.hidden = false;
        timerToggle.setAttribute("aria-expanded", "true");
        var selected = timerPanel.querySelector(".mf-artwork-option.is-selected");
        if (selected) selected.focus();
      }

      function chooseArtworkFit() {
        // Restore the original shared presentation for every theme. Individual
        // artwork overrides can be added later without changing the gallery.
        return "cover";
      }

      function applyArtworkPresentation(width, height) {
        artworkNaturalWidth = width || artworkNaturalWidth;
        artworkNaturalHeight = height || artworkNaturalHeight;
        var fit = chooseArtworkFit(artworkNaturalWidth, artworkNaturalHeight);
        lounge.style.setProperty("--mf-artwork-fit", fit);
        lounge.style.setProperty("--mf-artwork-position", "center");
        if (timerWidget) {
          timerWidget.style.setProperty("--mf-fullscreen-artwork-fit", fit);
          timerWidget.style.setProperty("--mf-fullscreen-artwork-position", "center");
        }
      }

      function applyArtworkFraming(id) {
        var scale = artworkScaleOverrides[id] || 1;
        lounge.style.setProperty("--mf-artwork-scale", String(scale));
        if (timerWidget) {
          timerWidget.style.setProperty("--mf-fullscreen-artwork-scale", String(scale));
        }
      }

      function loadArtworkStage(url) {
        if (artworkStage) {
          artworkStage.hidden = !url;
        }
        [artworkStageImage, timerArtworkStageImage].forEach(function (image) {
          if (!image) return;
          if (!url) {
            image.removeAttribute("src");
            return;
          }
          image.src = url;
        });
        if (artworkStageImage && url) {
          var syncNaturalSize = function () {
            applyArtworkPresentation(artworkStageImage.naturalWidth, artworkStageImage.naturalHeight);
          };
          if (artworkStageImage.complete) syncNaturalSize();
          else artworkStageImage.addEventListener("load", syncNaturalSize, { once: true });
        }
      }

      function selectArtwork(id, shouldSave) {
        var selected = options.find(function (option) {
          return option.getAttribute("data-artwork-id") === id;
        }) || options[0];
        var url = selected.getAttribute("data-artwork-url") || "";
        var selectedId = selected.getAttribute("data-artwork-id") || "original";

        lounge.classList.toggle("mf-has-artwork", Boolean(url));
        lounge.setAttribute("data-active-artwork", selectedId);
        applyArtworkFraming(selectedId);
        if (url) lounge.style.setProperty("--mf-artwork-url", "url(\"" + url + "\")");
        else lounge.style.removeProperty("--mf-artwork-url");
        loadArtworkStage(url);
        if (timerWidget) {
          if (url) timerWidget.style.setProperty("--mf-fullscreen-artwork-url", "url(\"" + url + "\")");
          else timerWidget.style.removeProperty("--mf-fullscreen-artwork-url");
        }

        options.concat(timerOptions).forEach(function (option) {
          var isSelected = option.getAttribute("data-artwork-id") === selectedId;
          option.classList.toggle("is-selected", isSelected);
          option.setAttribute("aria-selected", isSelected ? "true" : "false");
        });

        if (shouldSave) localStorage.setItem(storageKey, selectedId);
      }

      if (timerGrid && timerPanel && timerToggle && timerClose) {
        options.forEach(function (option) {
          var clone = option.cloneNode(true);
          clone.classList.add("mf-timer-artwork-option");
          clone.addEventListener("click", function () {
            selectArtwork(clone.getAttribute("data-artwork-id"), true);
            closeTimerPicker();
            timerToggle.focus();
          });
          timerGrid.appendChild(clone);
          timerOptions.push(clone);
        });

        setupArtworkThumbnailLoading(timerGrid, timerPanel);

        timerToggle.addEventListener("click", function () {
          if (timerPanel.hidden) openTimerPicker();
          else closeTimerPicker();
        });
        timerClose.addEventListener("click", function () {
          closeTimerPicker();
          timerToggle.focus();
        });
        document.addEventListener("fullscreenchange", function () {
          if (document.fullscreenElement !== timerWidget) closeTimerPicker();
        });
        document.addEventListener("webkitfullscreenchange", function () {
          if (document.webkitFullscreenElement !== timerWidget) closeTimerPicker();
        });
      }

      setupArtworkThumbnailLoading(panel, panel);
      scheduleArtworkThumbnailPreload(panel);

      selectArtwork(localStorage.getItem(storageKey) || "original", false);
      window.addEventListener("resize", function () {
        applyArtworkPresentation(artworkNaturalWidth, artworkNaturalHeight);
      });

      toggle.addEventListener("click", function () {
        setChatDrawer(false, false);
        panel.hidden = !panel.hidden;
        toggle.setAttribute("aria-expanded", panel.hidden ? "false" : "true");
      });
      close.addEventListener("click", closePicker);
      options.forEach(function (option) {
        option.addEventListener("click", function () {
          selectArtwork(option.getAttribute("data-artwork-id"), true);
          closePicker();
        });
      });
      document.addEventListener("click", function (event) {
        if (!panel.hidden && !picker.contains(event.target)) closePicker();
      });
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && timerPanel && !timerPanel.hidden) {
          closeTimerPicker();
          timerToggle.focus();
          return;
        }
        if (event.key === "Escape" && !panel.hidden) {
          closePicker();
          toggle.focus();
        }
      });
    }

    function setupVideoMode() {
      var video = document.getElementById("mf-video");
      var toggle = document.getElementById("mf-video-toggle");
      var expand = document.getElementById("mf-video-expand");
      var compactPlay = document.getElementById("mf-video-compact-play");
      var compactMusic = document.getElementById("mf-video-compact-music");
      var compactThumb = document.querySelector("#mf-video-compact > img");
      var compactTitle = document.querySelector(".mf-video-compact-copy strong");
      var compactSubtitle = document.querySelector(".mf-video-compact-copy span");
      var compactWaveform = document.getElementById("mf-video-waveform");
      var musicToggle = document.getElementById("mf-music-picker-toggle");
      var currentSoundLabel = document.getElementById("mf-current-sound-label");
      var musicPanel = document.getElementById("mf-music-picker-panel");
      var musicClose = document.getElementById("mf-music-picker-close");
      var musicOptions = Array.prototype.slice.call(document.querySelectorAll(".mf-music-option"));
      var player = document.getElementById("mf-lofi-player");
      var storageKey = "memoryfuelVideoModeV2";
      var musicStorageKey = "memoryfuelStudySoundV1";
      var isPlaying = false;
      var selectedSound = "Asian Lofi";
      if (!video || !toggle || !expand || !compactPlay || !compactMusic || !musicToggle || !musicPanel || !musicClose || !player || !musicOptions.length) return;

      function sendYoutubeCommand(command) {
        if (!player.contentWindow) return;
        player.contentWindow.postMessage(JSON.stringify({
          event: "command",
          func: command,
          args: []
        }), "https://www.youtube.com");
      }

      function setPlaying(playing) {
        isPlaying = playing;
        compactPlay.classList.toggle("is-playing", playing);
        if (compactWaveform) compactWaveform.classList.toggle("is-playing", playing);
        compactPlay.setAttribute("aria-label", (playing ? "Pause " : "Play ") + selectedSound + " study sound");
        compactPlay.setAttribute("title", playing ? "Pause" : "Play");
      }

      function closeMusicPicker(returnFocus) {
        musicPanel.hidden = true;
        musicToggle.setAttribute("aria-expanded", "false");
        compactMusic.setAttribute("aria-expanded", "false");
        video.classList.remove("is-choosing-music");
        if (returnFocus) returnFocus.focus();
      }

      function openMusicPicker() {
        musicPanel.hidden = false;
        musicToggle.setAttribute("aria-expanded", "true");
        compactMusic.setAttribute("aria-expanded", "true");
        video.classList.add("is-choosing-music");
        var activeOption = musicPanel.querySelector(".mf-music-option.is-active");
        if (activeOption) activeOption.focus();
      }

      function toggleMusicPicker() {
        if (musicPanel.hidden) openMusicPicker();
        else closeMusicPicker();
      }

      function selectMusicOption(option, shouldSave) {
        if (!option) return;
        var youtubeId = option.getAttribute("data-youtube-id");
        var trackLabel = option.getAttribute("data-track-label") || "Study sound";
        var trackTitle = option.getAttribute("data-track-title") || trackLabel;
        var trackSubtitle = option.getAttribute("data-track-subtitle") || "YouTube study audio";
        if (!youtubeId) return;

        selectedSound = trackLabel;
        musicOptions.forEach(function (musicOption) {
          var isSelected = musicOption === option;
          musicOption.classList.toggle("is-active", isSelected);
          musicOption.setAttribute("aria-checked", isSelected ? "true" : "false");
        });
        if (currentSoundLabel) currentSoundLabel.textContent = trackLabel;
        if (compactTitle) compactTitle.textContent = trackTitle;
        if (compactSubtitle) compactSubtitle.textContent = trackSubtitle;
        if (compactThumb) {
          compactThumb.src = "https://i.ytimg.com/vi/" + youtubeId + "/mqdefault.jpg";
          compactThumb.alt = trackLabel + " YouTube thumbnail";
        }
        player.title = trackTitle + " on YouTube";
        if (player.getAttribute("data-youtube-id") !== youtubeId) {
          player.setAttribute("data-youtube-id", youtubeId);
          player.src = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=0&mute=0&controls=1&rel=0&enablejsapi=1";
          setPlaying(false);
        } else {
          setPlaying(isPlaying);
        }
        if (shouldSave) localStorage.setItem(musicStorageKey, youtubeId);
      }

      function applyVideoMode(minimized, shouldSave) {
        video.classList.toggle("is-minimized", minimized);
        toggle.setAttribute("aria-pressed", minimized ? "true" : "false");
        toggle.setAttribute("aria-label", "Minimize the YouTube player");
        toggle.setAttribute("title", "Minimize video");
        if (shouldSave) localStorage.setItem(storageKey, minimized ? "compact" : "full");
      }

      var savedMusicId = localStorage.getItem(musicStorageKey);
      var savedMusicOption = musicOptions.filter(function (option) {
        return option.getAttribute("data-youtube-id") === savedMusicId;
      })[0];
      selectMusicOption(savedMusicOption || musicOptions[0], false);
      applyVideoMode(localStorage.getItem(storageKey) !== "full", false);
      toggle.addEventListener("click", function () {
        closeMusicPicker();
        applyVideoMode(true, true);
      });
      expand.addEventListener("click", function () {
        closeMusicPicker();
        applyVideoMode(false, true);
        toggle.focus();
      });
      compactPlay.addEventListener("click", function () {
        sendYoutubeCommand(isPlaying ? "pauseVideo" : "playVideo");
        setPlaying(!isPlaying);
      });
      musicToggle.addEventListener("click", toggleMusicPicker);
      compactMusic.addEventListener("click", toggleMusicPicker);
      musicClose.addEventListener("click", function () {
        closeMusicPicker(video.classList.contains("is-minimized") ? compactMusic : musicToggle);
      });
      musicOptions.forEach(function (option) {
        option.addEventListener("click", function () {
          selectMusicOption(option, true);
          closeMusicPicker(video.classList.contains("is-minimized") ? compactMusic : musicToggle);
        });
      });
      document.addEventListener("click", function (event) {
        if (musicPanel.hidden || musicPanel.contains(event.target) || musicToggle.contains(event.target) || compactMusic.contains(event.target)) return;
        closeMusicPicker();
      });
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" || musicPanel.hidden) return;
        closeMusicPicker(video.classList.contains("is-minimized") ? compactMusic : musicToggle);
      });
      window.addEventListener("message", function (event) {
        if (event.source !== player.contentWindow) return;
        var payload = event.data;
        try { if (typeof payload === "string") payload = JSON.parse(payload); } catch (error) { return; }
        if (!payload || payload.event !== "infoDelivery" || !payload.info || typeof payload.info.playerState !== "number") return;
        setPlaying(payload.info.playerState === 1);
      });
    }

    var db = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
    var currentUser = null;
    var presenceChannel = null;
    var saveBuffer = 0;
    var saveInFlight = 0;
    var studyTimeFlushPromise = null;
    var currentSessionId = null;
    var currentSessionSeconds = 0;
    var activeLeaderboard = "leaderboard_today";
    var leaderboardPage = 0;
    var leaderboardPageSize = 100;
    var chatChannel = null;
    var chatRoom = getDailyChatRoom();
    var chatUnreadStorageKey = "memoryfuelStudyChatReadV1";
    var chatUnreadCount = 0;
    var chatAttachmentObjectUrl = "";
    var shopifyBridgeInFlight = false;
    var shopifyBridgePollId = null;
    var profileNameCache = {};
    var profileAvatarCache = {};
    var studyRows = [];
    var checklistItems = [];
    var calendarTasks = {};
    var selectedCalendarDate = new Date();
    var calendarTaskStorageKey = "memoryfuelStudyCalendarTasksV1";
    var calendarLoadedForUser = null;
    var studyTracker = {
      view: "month",
      anchor: new Date()
    };
    var timerDurations = {
      focus: 25,
      short: 5,
      long: 15
    };
    var gentleChimeStorageKey = "memoryfuelGentleTimerChimeV1";
    var timerStateStorageKey = "memoryfuelPomodoroStateV1";
    var displayNameStorageKey = "memoryfuelStudyDisplayNameV1";
    var gentleChimeEnabled = localStorage.getItem(gentleChimeStorageKey) !== "off";
    var timerAudioContext = null;
    var calmStartStorageKey = "memoryfuelCalmStartV1";
    var calmStartState = {
      date: "",
      focus: "",
      goalMinutes: 50,
      notes: ""
    };

    var timer = {
      mode: "focus",
      duration: 25 * 60,
      remaining: 25 * 60,
      running: false,
      tickId: null,
      lastTick: null,
      animationFrameId: null,
      visualStartedAt: null,
      visualStartRemaining: 25 * 60
    };
    var timerRestoredForUser = null;

    function getDailyChatRoom() {
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, "0");
      var day = String(now.getDate()).padStart(2, "0");
      return "main-" + year + "-" + month + "-" + day;
    }

    var stats = {
      todaySeconds: 0,
      totalSeconds: 0,
      streak: 0
    };

    var el = {
      communityView: document.getElementById("mf-community-view"),
      timerWidget: document.getElementById("mf-timer-widget"),
      timerFullscreen: document.getElementById("mf-timer-fullscreen"),
      authView: document.getElementById("mf-auth-view"),
      appView: document.getElementById("mf-app-view"),
      authMessage: document.getElementById("mf-auth-message"),
      shopifyAccount: document.getElementById("mf-shopify-account"),
      shopifyContinue: document.getElementById("mf-shopify-continue"),
      ageGate: document.getElementById("mf-age-gate"),
      ageCheckView: document.getElementById("mf-age-check-view"),
      under13View: document.getElementById("mf-under-13-view"),
      birthMonth: document.getElementById("mf-birth-month"),
      birthYear: document.getElementById("mf-birth-year"),
      ageContinue: document.getElementById("mf-age-continue"),
      ageMessage: document.getElementById("mf-age-message"),
      enterGuest: document.getElementById("mf-enter-guest"),
      console: document.querySelector(".mf-console"),
      lounge: document.querySelector(".mf-study-lounge"),
      loungeGreeting: document.querySelector(".mf-lounge-intro"),
      loungeGreetingKicker: document.getElementById("mf-lounge-greeting-kicker"),
      loungeGreetingName: document.getElementById("mf-lounge-greeting-name"),
      loungeLockin: document.getElementById("mf-lounge-lockin"),
      loungeLockinName: document.getElementById("mf-lounge-lockin-name"),
      chatDrawerToggle: document.getElementById("mf-chat-drawer-toggle"),
      chatUnreadBadge: document.getElementById("mf-chat-unread-badge"),
      accountToggle: document.getElementById("mf-account-toggle"),
      accountToggleLabel: document.getElementById("mf-account-toggle-label"),
      accountPanel: document.getElementById("mf-account-panel"),
      accountClose: document.getElementById("mf-account-close"),
      accountSignedOut: document.getElementById("mf-account-signed-out"),
      accountSignedIn: document.getElementById("mf-account-signed-in"),
      accountGuest: document.getElementById("mf-account-guest"),
      accountEmail: document.getElementById("mf-account-email"),
      accountSendLink: document.getElementById("mf-account-send-link"),
      accountEmailLabel: document.getElementById("mf-account-email-label"),
      accountDisplayName: document.getElementById("mf-account-display-name"),
      accountSaveName: document.getElementById("mf-account-save-name"),
      accountLogout: document.getElementById("mf-account-logout"),
      accountStatus: document.getElementById("mf-account-status"),
      userEmail: document.getElementById("mf-user-email"),
      perkBadge: document.getElementById("mf-perk-badge"),
      avatarPreview: document.getElementById("mf-avatar-preview"),
      toggleAvatar: document.getElementById("mf-toggle-avatar"),
      avatarUpload: document.getElementById("mf-avatar-upload"),
      avatarOptions: document.getElementById("mf-avatar-options"),
      onlineCount: document.getElementById("mf-online-count"),
      time: document.getElementById("mf-time"),
      timerModeLabel: document.getElementById("mf-timer-mode-label"),
      timerRing: document.getElementById("mf-timer-ring"),
      gentleChime: document.getElementById("mf-gentle-chime"),
      focusMinutes: document.getElementById("mf-focus-minutes"),
      shortMinutes: document.getElementById("mf-short-minutes"),
      longMinutes: document.getElementById("mf-long-minutes"),
      start: document.getElementById("mf-start"),
      pause: document.getElementById("mf-pause"),
      reset: document.getElementById("mf-reset"),
      today: document.getElementById("mf-today"),
      total: document.getElementById("mf-total"),
      streakLabel: document.getElementById("mf-streak-label"),
      streakDays: document.getElementById("mf-streak-days"),
      streakCount: document.getElementById("mf-streak-count"),
      streakProgress: document.getElementById("mf-streak-progress"),
      streakDots: document.getElementById("mf-streak-dots"),
      weekTotal: document.getElementById("mf-week-total"),
      hoursChart: document.getElementById("mf-hours-chart"),
      studyRangeLabel: document.getElementById("mf-study-range-label"),
      studyRangeTitle: document.getElementById("mf-study-range-title"),
      studyRangeTotal: document.getElementById("mf-study-total-range"),
      studyRangeBest: document.getElementById("mf-study-best-range"),
      studyRangeAverage: document.getElementById("mf-study-average-range"),
      studyPrev: document.getElementById("mf-study-prev"),
      studyNext: document.getElementById("mf-study-next"),
      calendarAdd: document.getElementById("mf-calendar-add"),
      calendarDialog: document.getElementById("mf-calendar-dialog"),
      calendarClose: document.getElementById("mf-calendar-close"),
      calendarDialogTitle: document.getElementById("mf-calendar-dialog-title"),
      calendarDialogSummary: document.getElementById("mf-calendar-dialog-summary"),
      calendarTaskForm: document.getElementById("mf-calendar-task-form"),
      calendarTaskTitle: document.getElementById("mf-calendar-task-title"),
      calendarTaskStatus: document.getElementById("mf-calendar-task-status"),
      calendarTaskPriority: document.getElementById("mf-calendar-task-priority"),
      calendarTaskList: document.getElementById("mf-calendar-task-list"),
      calendarUpcomingList: document.getElementById("mf-calendar-upcoming-list"),
      calendarUpcomingSummary: document.getElementById("mf-calendar-upcoming-summary"),
      taskInput: document.getElementById("mf-task-input"),
      addTask: document.getElementById("mf-add-task"),
      clearDone: document.getElementById("mf-clear-done"),
      taskList: document.getElementById("mf-task-list"),
      checklistCount: document.getElementById("mf-checklist-count"),
      dailyFocusInput: document.getElementById("mf-daily-focus-input"),
      saveDailyFocus: document.getElementById("mf-save-daily-focus"),
      focusGoal: document.getElementById("mf-focus-goal"),
      focusGoalSummary: document.getElementById("mf-focus-goal-summary"),
      focusProgressBar: document.getElementById("mf-focus-progress-bar"),
      focusEncouragement: document.getElementById("mf-focus-encouragement"),
      quickNotes: document.getElementById("mf-quick-notes"),
      notesStatus: document.getElementById("mf-notes-status"),
      status: document.getElementById("mf-status"),
      board: document.getElementById("mf-leaderboard-list"),
      refreshBoard: document.getElementById("mf-refresh-board"),
      boardPagination: document.getElementById("mf-leaderboard-pagination"),
      boardPrev: document.getElementById("mf-leaderboard-prev"),
      boardNext: document.getElementById("mf-leaderboard-next"),
      boardPage: document.getElementById("mf-leaderboard-page"),
      boardRange: document.getElementById("mf-leaderboard-range"),
      chatMessages: document.getElementById("mf-chat-messages"),
      chatInput: document.getElementById("mf-chat-input"),
      chatMedia: document.getElementById("mf-chat-media"),
      chatAttachment: document.getElementById("mf-chat-attachment"),
      chatAttachmentPreview: document.getElementById("mf-chat-attachment-preview"),
      chatAttachmentName: document.getElementById("mf-chat-attachment-name"),
      removeChatMedia: document.getElementById("mf-remove-chat-media"),
      sendChat: document.getElementById("mf-send-chat"),
      chatStatus: document.getElementById("mf-chat-status"),
      toggleChat: document.getElementById("mf-toggle-chat"),
      toggleChatLabel: document.getElementById("mf-toggle-chat-label"),
      chatBody: document.getElementById("mf-chat-body"),
      chatDisabled: document.getElementById("mf-chat-disabled"),
      boardTabs: Array.prototype.slice.call(document.querySelectorAll(".mf-board-tab")),
      studyTabs: Array.prototype.slice.call(document.querySelectorAll(".mf-study-tab")),
      modes: Array.prototype.slice.call(document.querySelectorAll(".mf-mode"))
    };

    window.MemoryFuelStudyLounge = {
      db: db,
      getCurrentUser: function () { return currentUser; },
      refreshCalendar: function () {
        calendarLoadedForUser = null;
        return loadCalendarTasks();
      },
      refreshChecklist: function () {
        return loadChecklist();
      },
      startPomodoro: function (minutes, mode) {
        var safeMinutes = Math.max(1, Math.min(180, Number(minutes) || 25));
        var safeMode = ["focus", "short", "long"].indexOf(mode) >= 0 ? mode : "focus";
        pauseTimer();
        timer.mode = safeMode;
        timerDurations[safeMode] = safeMinutes;
        timer.duration = safeMinutes * 60;
        timer.remaining = timer.duration;
        el.modes.forEach(function (button) {
          button.classList.toggle("active", button.getAttribute("data-mode") === safeMode);
        });
        renderTimer();
        startTimer();
        return { ok: timer.running, minutes: safeMinutes, mode: safeMode };
      },
      openSmartSyllabus: function () {
        var button = document.getElementById("mf-smart-planner-open");
        if (button) button.click();
      },
      openFlashcards: function (tab) {
        if (window.MemoryFuelFlashcards && window.MemoryFuelFlashcards.open) {
          window.MemoryFuelFlashcards.open(tab || "create");
          return;
        }
        window.dispatchEvent(new CustomEvent("memoryfuel:flashcards-open", {
          detail: { tab: tab || "create" }
        }));
      }
    };
    window.dispatchEvent(new CustomEvent("memoryfuel:study-lounge-ready"));

    setupCalmStart();
    setupStudyCalendarTasks();
    setupAgeGate();
    renderAvatarOptions();
    el.accountToggle.addEventListener("click", toggleAccountPanel);
    el.accountClose.addEventListener("click", closeAccountPanel);
    el.accountSendLink.addEventListener("click", sendAccountMagicLink);
    el.shopifyContinue.addEventListener("click", function () {
      localStorage.removeItem("memoryfuelStudyBridgePaused");
      attemptShopifyBridge(false);
    });
    el.accountSaveName.addEventListener("click", saveAccountDisplayName);
    el.accountLogout.addEventListener("click", logout);
    document.addEventListener("click", function (event) {
      if (!el.accountPanel.hidden && !el.accountPanel.contains(event.target) && !el.accountToggle.contains(event.target)) closeAccountPanel();
    });
    window.addEventListener("focus", function () {
      if (!currentUser && ageBand === AGE_BAND_13_PLUS && !el.accountPanel.hidden) attemptShopifyBridge(true);
    });
    el.toggleAvatar.addEventListener("click", toggleAvatarOptions);
    el.avatarUpload.addEventListener("change", uploadAvatar);
    el.start.addEventListener("click", startTimer);
    el.pause.addEventListener("click", pauseTimer);
    el.reset.addEventListener("click", resetTimer);
    window.addEventListener("beforeunload", persistTimerState);
    window.addEventListener("pagehide", persistTimerState);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") persistTimerState();
    });
    document.addEventListener("freeze", persistTimerState);
    el.timerFullscreen.addEventListener("click", toggleTimerFullscreen);
    document.addEventListener("fullscreenchange", syncTimerFullscreenButton);
    document.addEventListener("webkitfullscreenchange", syncTimerFullscreenButton);
    el.gentleChime.checked = gentleChimeEnabled;
    el.gentleChime.addEventListener("change", function () {
      gentleChimeEnabled = el.gentleChime.checked;
      localStorage.setItem(gentleChimeStorageKey, gentleChimeEnabled ? "on" : "off");
      el.status.textContent = gentleChimeEnabled
        ? "Gentle timer chime is on."
        : "Gentle timer chime is off.";
      if (gentleChimeEnabled) prepareGentleChime();
    });
    el.refreshBoard.addEventListener("click", loadLeaderboard);
    if (el.boardPrev) el.boardPrev.addEventListener("click", function () {
      if (leaderboardPage <= 0) return;
      leaderboardPage -= 1;
      loadLeaderboard();
    });
    if (el.boardNext) el.boardNext.addEventListener("click", function () {
      leaderboardPage += 1;
      loadLeaderboard();
    });
    if (el.boardPage) el.boardPage.addEventListener("change", function () {
      leaderboardPage = Math.max(0, Number(el.boardPage.value) || 0);
      loadLeaderboard();
    });
    window.addEventListener("mf:quick-view-open", function (event) {
      if (!event.detail || event.detail.tool !== "leaderboard") return;
      leaderboardPage = 0;
      loadLeaderboard();
    });
    window.addEventListener("mf:quick-view-close", function (event) {
      if (!event.detail || event.detail.tool !== "leaderboard") return;
      leaderboardPage = 0;
      loadLeaderboard();
    });
    el.studyPrev.addEventListener("click", function () {
      moveStudyRange(-1);
    });
    el.studyNext.addEventListener("click", function () {
      moveStudyRange(1);
    });
    [el.focusMinutes, el.shortMinutes, el.longMinutes].forEach(function (input) {
      input.addEventListener("change", updateTimerDurations);
    });
    el.addTask.addEventListener("click", addChecklistTask);
    el.clearDone.addEventListener("click", clearDoneTasks);
    el.taskInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        addChecklistTask();
      }
    });
    el.sendChat.addEventListener("click", sendChatMessage);
    el.chatMedia.addEventListener("change", previewChatAttachment);
    el.removeChatMedia.addEventListener("click", clearChatAttachment);
    el.chatDrawerToggle.addEventListener("click", toggleChatDrawer);
    el.toggleChat.addEventListener("click", function () { setChatDrawer(false, true); });
    document.addEventListener("click", function (event) {
      if (!el.lounge.classList.contains("mf-chat-drawer-open")) return;
      if (el.console.contains(event.target) || el.chatDrawerToggle.contains(event.target)) return;
      setChatDrawer(false, false);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && el.lounge.classList.contains("mf-chat-drawer-open")) {
        setChatDrawer(false, true);
      }
    });
    el.chatInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        sendChatMessage();
      }
    });

    el.boardTabs.forEach(function (button) {
      button.addEventListener("click", function () {
        activeLeaderboard = button.getAttribute("data-board");
        leaderboardPage = 0;
        el.boardTabs.forEach(function (tab) {
          tab.classList.toggle("active", tab === button);
        });
        loadLeaderboard();
      });
    });

    el.studyTabs.forEach(function (button) {
      button.addEventListener("click", function () {
        studyTracker.view = button.getAttribute("data-study-view") || "week";
        el.studyTabs.forEach(function (tab) {
          tab.classList.toggle("active", tab === button);
        });
        renderStudyProgress();
      });
    });

    el.modes.forEach(function (button) {
      button.addEventListener("click", function () {
        pauseTimer();
        timer.mode = button.getAttribute("data-mode");
        timer.duration = timerDurations[timer.mode] * 60;
        timer.remaining = timer.duration;
        el.modes.forEach(function (modeButton) {
          modeButton.classList.toggle("active", modeButton === button);
        });
        renderTimer();
        persistTimerState();
      });
    });

    db.auth.onAuthStateChange(function (_event, session) {
      currentUser = session ? session.user : null;
      if (ageBand !== AGE_BAND_13_PLUS) return;
      if (currentUser) {
        localStorage.setItem("memoryfuelStudyAuthComplete", String(Date.now()));
        if (window.location.hash || window.location.search.indexOf("code=") >= 0) {
          window.history.replaceState({}, document.title, STUDY_LOUNGE_URL);
        }
      }
      renderAuthState();
    });

    window.addEventListener("storage", function (event) {
      if (event.key !== "memoryfuelStudyAuthComplete") return;
      db.auth.getSession().then(function (result) {
        currentUser = result.data.session ? result.data.session.user : null;
        renderAuthState();
      });
    });

    boot();

    async function boot() {
      var result = await db.auth.getSession();
      currentUser = result.data.session ? result.data.session.user : null;
      await applyAgeGateState();
    }

    async function sendAccountMagicLink() {
      return sendMagicLinkFor(el.accountEmail, el.accountSendLink, el.accountStatus);
    }

    async function sendMagicLinkFor(emailInput, button, status) {
      if (ageBand !== AGE_BAND_13_PLUS) {
        showAgeGate();
        return;
      }
      var email = emailInput.value.trim();
      if (!email) {
        status.textContent = "Enter your email first.";
        return;
      }

      button.disabled = true;
      status.textContent = "Sending login link...";
      localStorage.setItem("memoryfuelStudyAuthWaiting", "yes");

      var result = await db.auth.signInWithOtp({
        email: email,
        options: { emailRedirectTo: STUDY_LOUNGE_URL }
      });

      button.disabled = false;
      status.textContent = result.error
        ? result.error.message
        : "Check your email. Keep this page open—it will update automatically after you use the link.";
    }

    function toggleAccountPanel() {
      if (el.accountPanel.hidden) setChatDrawer(false, false);
      el.accountPanel.hidden = !el.accountPanel.hidden;
      el.accountToggle.setAttribute("aria-expanded", el.accountPanel.hidden ? "false" : "true");
      if (!el.accountPanel.hidden) {
        var target = currentUser
          ? el.accountDisplayName
          : ageBand === AGE_BAND_UNDER_13 ? el.accountClose : el.shopifyContinue;
        window.setTimeout(function () { target.focus(); }, 0);
        if (!currentUser && ageBand === AGE_BAND_13_PLUS) startShopifyBridgePolling();
      } else {
        stopShopifyBridgePolling();
      }
    }

    function closeAccountPanel() {
      stopShopifyBridgePolling();
      el.accountPanel.hidden = true;
      el.accountToggle.setAttribute("aria-expanded", "false");
    }

    async function saveAccountDisplayName() {
      if (!currentUser) return;
      await saveDisplayName();
      el.accountStatus.textContent = "Username saved.";
    }

    async function logout() {
      closeAccountPanel();
      pauseTimer();
      localStorage.setItem("memoryfuelStudyBridgePaused", "yes");
      if (presenceChannel) {
        await presenceChannel.untrack();
        await db.removeChannel(presenceChannel);
        presenceChannel = null;
      }
      if (chatChannel) {
        await db.removeChannel(chatChannel);
        chatChannel = null;
      }
      await db.auth.signOut();
    }

    async function renderAuthState() {
      if (ageBand !== AGE_BAND_13_PLUS) {
        await applyAgeGateState();
        return;
      }

      el.lounge.classList.remove("mf-age-pending", "mf-guest-mode");
      el.ageGate.hidden = true;
      el.accountGuest.hidden = true;
      el.chatDrawerToggle.disabled = false;
      if (!currentUser) {
        setLoungeGreeting("");
        timerRestoredForUser = null;
        updateChatUnreadBadge(0);
        setChatDrawer(false, false);
        el.authView.hidden = false;
        el.appView.hidden = true;
        el.communityView.hidden = true;
        el.timerWidget.hidden = true;
        el.console.hidden = true;
        el.onlineCount.textContent = "Login required";
        el.chatDrawerToggle.setAttribute("aria-label", "Sign in to open Study Room live chat");
        calendarLoadedForUser = null;
        calendarTasks = {};
        el.accountToggle.classList.remove("is-signed-in");
        el.accountToggleLabel.textContent = "Sign in";
        el.accountSignedOut.hidden = false;
        el.accountSignedIn.hidden = true;
        el.accountStatus.textContent = "Sign in once with Memory Fuel to open your Study Lounge profile.";
        el.authMessage.textContent = "Choose Shop, Google, or an email verification code. This page will update automatically.";
        if (localStorage.getItem("memoryfuelStudyBridgePaused") !== "yes") {
          window.setTimeout(function () { attemptShopifyBridge(true); }, 0);
        }
        window.dispatchEvent(new CustomEvent("memoryfuel:auth-state", { detail: { user: null } }));
        return;
      }

      el.authView.hidden = true;
      el.appView.hidden = false;
      el.communityView.hidden = false;
      el.timerWidget.hidden = false;
      el.console.hidden = false;
      el.chatDrawerToggle.setAttribute("aria-label", "Open Study Room live chat");
      el.userEmail.textContent = currentUser.email || "";
      el.accountToggle.classList.add("is-signed-in");
      el.accountToggleLabel.textContent = "Account";
      el.accountSignedOut.hidden = true;
      el.accountSignedIn.hidden = false;
      el.accountEmailLabel.textContent = currentUser.email || "";
      el.accountStatus.textContent = "Update the username shown in the Study Lounge.";
      stopShopifyBridgePolling();

      var shopifySessionIsValid = await verifyShopifySession();
      if (!shopifySessionIsValid) return;

      await ensureProfile();
      restoreTimerState();
      await saveAgeEligibility();
      await loadCustomerPerks();
      await loadStats();
      await loadCalendarTasks();
      await loadChecklist();
      await loadLeaderboard();
      await loadChatMessages();
      setupPresence();
      setupChat();
      renderTimer();
      window.dispatchEvent(new CustomEvent("memoryfuel:auth-state", { detail: { user: currentUser } }));
    }

    function readAgeBand() {
      try {
        var stored = localStorage.getItem(AGE_BAND_STORAGE_KEY);
        return stored === AGE_BAND_13_PLUS || stored === AGE_BAND_UNDER_13 ? stored : "";
      } catch (_error) {
        return "";
      }
    }

    function storeAgeBand(value) {
      ageBand = value;
      try { localStorage.setItem(AGE_BAND_STORAGE_KEY, value); } catch (_error) {}
    }

    function setupAgeGate() {
      var currentYear = new Date().getFullYear();
      for (var year = currentYear; year >= currentYear - 120; year -= 1) {
        var option = document.createElement("option");
        option.value = String(year);
        option.textContent = String(year);
        el.birthYear.appendChild(option);
      }
      el.ageContinue.addEventListener("click", handleAgeContinue);
      el.enterGuest.addEventListener("click", function () {
        el.ageGate.hidden = true;
        renderGuestState();
      });
    }

    function showAgeGate() {
      el.lounge.classList.add("mf-age-pending");
      el.ageCheckView.hidden = false;
      el.under13View.hidden = true;
      el.ageGate.hidden = false;
      window.setTimeout(function () { el.birthMonth.focus(); }, 0);
    }

    async function handleAgeContinue() {
      var month = Number(el.birthMonth.value);
      var year = Number(el.birthYear.value);
      var now = new Date();
      if (!month || !year) {
        el.ageMessage.textContent = "Choose both your birth month and birth year.";
        return;
      }
      if (year > now.getFullYear() || year < now.getFullYear() - 120) {
        el.ageMessage.textContent = "Check the year and try again.";
        return;
      }

      el.ageMessage.textContent = "";
      var eligibleOn = new Date(year + 13, month, 1);
      if (now >= eligibleOn) {
        storeAgeBand(AGE_BAND_13_PLUS);
        el.ageGate.hidden = true;
        await renderAuthState();
        if (!currentUser) {
          el.accountPanel.hidden = false;
          el.accountToggle.setAttribute("aria-expanded", "true");
          window.setTimeout(function () { el.accountEmail.focus(); }, 0);
        }
        return;
      }

      storeAgeBand(AGE_BAND_UNDER_13);
      if (currentUser) {
        await db.auth.signOut();
        currentUser = null;
      }
      el.ageCheckView.hidden = true;
      el.under13View.hidden = false;
    }

    async function applyAgeGateState() {
      if (ageBand === AGE_BAND_13_PLUS) {
        await renderAuthState();
        return;
      }
      if (ageBand === AGE_BAND_UNDER_13) {
        if (currentUser) {
          await db.auth.signOut();
          currentUser = null;
        }
        el.ageGate.hidden = true;
        renderGuestState();
        return;
      }

      setChatDrawer(false, false);
      el.communityView.hidden = true;
      el.timerWidget.hidden = true;
      el.console.hidden = true;
      showAgeGate();
    }

    function renderGuestState() {
      setChatDrawer(false, false);
      el.lounge.classList.remove("mf-age-pending");
      el.lounge.classList.add("mf-guest-mode");
      el.authView.hidden = true;
      el.appView.hidden = true;
      el.communityView.hidden = true;
      el.timerWidget.hidden = false;
      el.console.hidden = true;
      el.accountSignedOut.hidden = true;
      el.accountSignedIn.hidden = true;
      el.accountGuest.hidden = false;
      el.accountToggle.classList.remove("is-signed-in");
      el.accountToggleLabel.textContent = "Guest";
      el.accountStatus.textContent = "Guest tools do not create a personal Study Lounge account.";
      el.onlineCount.textContent = "13+ account required";
      el.chatDrawerToggle.disabled = true;
      calendarLoadedForUser = null;
      calendarTasks = {};
      renderTimer();
      window.dispatchEvent(new CustomEvent("memoryfuel:auth-state", { detail: { user: null, guest: true } }));
    }

    async function saveAgeEligibility() {
      if (!currentUser || ageBand !== AGE_BAND_13_PLUS) return;
      await db.from("study_lounge_age_eligibility").upsert({
        user_id: currentUser.id,
        age_band: AGE_BAND_13_PLUS,
        confirmed_at: new Date().toISOString()
      }, { onConflict: "user_id" });
    }

    function startShopifyBridgePolling() {
      stopShopifyBridgePolling();
      attemptShopifyBridge(true);
      shopifyBridgePollId = window.setInterval(function () {
        if (currentUser || el.accountPanel.hidden || ageBand !== AGE_BAND_13_PLUS) {
          stopShopifyBridgePolling();
          return;
        }
        attemptShopifyBridge(true);
      }, 6000);
    }

    function stopShopifyBridgePolling() {
      if (!shopifyBridgePollId) return;
      window.clearInterval(shopifyBridgePollId);
      shopifyBridgePollId = null;
    }

    async function attemptShopifyBridge(quiet) {
      if (shopifyBridgeInFlight || currentUser || ageBand !== AGE_BAND_13_PLUS) return;
      if (quiet && localStorage.getItem("memoryfuelStudyBridgePaused") === "yes") return;

      shopifyBridgeInFlight = true;
      el.shopifyContinue.disabled = true;
      if (!quiet) el.accountStatus.textContent = "Checking your Memory Fuel sign-in...";

      try {
        var response = await fetch(SHOPIFY_BRIDGE_URL, {
          method: "GET",
          credentials: "same-origin",
          cache: "no-store",
          headers: { Accept: "application/json" }
        });
        var payload = await response.json().catch(function () { return {}; });

        if (response.status === 401 && payload.code === "shopify_sign_in_required") {
          if (!quiet) el.accountStatus.textContent = "Choose a Shopify sign-in option, then select the button again.";
          return;
        }
        if (!response.ok || !payload.token_hash) {
          if (!quiet) el.accountStatus.textContent = payload.error || "We could not confirm the Shopify account yet.";
          return;
        }

        el.accountStatus.textContent = "Opening your Study Lounge...";
        var verification = await db.auth.verifyOtp({
          token_hash: payload.token_hash,
          type: payload.token_type || "magiclink"
        });
        if (verification.error) throw verification.error;
        localStorage.removeItem("memoryfuelStudyBridgePaused");
        stopShopifyBridgePolling();
      } catch (_error) {
        if (!quiet) el.accountStatus.textContent = "We could not finish signing you in. Please try again.";
      } finally {
        shopifyBridgeInFlight = false;
        el.shopifyContinue.disabled = false;
      }
    }

    async function verifyShopifySession() {
      try {
        var response = await fetch(SHOPIFY_BRIDGE_URL + "?check=1", {
          method: "GET",
          credentials: "same-origin",
          cache: "no-store",
          headers: { Accept: "application/json" }
        });
        if (response.ok) return true;
        var payload = await response.json().catch(function () { return {}; });
        if (response.status !== 401 || payload.code !== "shopify_sign_in_required") return true;

        await db.auth.signOut();
        currentUser = null;
        el.accountPanel.hidden = false;
        el.accountToggle.setAttribute("aria-expanded", "true");
        el.accountStatus.textContent = "Sign in with your Memory Fuel account to continue.";
        return false;
      } catch (_error) {
        return true;
      }
    }

    async function ensureProfile() {
      var defaultName = (currentUser.email || "Student").split("@")[0];
      var cachedDisplayName = readCachedDisplayName(currentUser.id);
      setLoungeGreeting(cachedDisplayName);

      await db.from("profiles").upsert({
        id: currentUser.id,
        display_name: defaultName
      }, { onConflict: "id", ignoreDuplicates: true });

      var result = await db
        .from("profiles")
        .select("display_name,avatar_url")
        .eq("id", currentUser.id)
        .single();

      if (!result.error && result.data) {
        el.accountDisplayName.value = result.data.display_name || defaultName;
        setLoungeGreeting(el.accountDisplayName.value);
        cacheDisplayName(currentUser.id, el.accountDisplayName.value);
        profileNameCache[currentUser.id] = el.accountDisplayName.value;
        profileAvatarCache[currentUser.id] = result.data.avatar_url || "";
        renderAvatar(result.data.avatar_url);
      }
    }

    async function saveDisplayName() {
      if (!currentUser) return;
      var displayName = el.accountDisplayName.value.trim() || "Student";

      await db
        .from("profiles")
        .update({ display_name: displayName, updated_at: new Date().toISOString() })
        .eq("id", currentUser.id);

      await loadLeaderboard();
      if (presenceChannel) {
        await presenceChannel.track(presencePayload());
      }
      profileNameCache[currentUser.id] = displayName;
      el.accountDisplayName.value = displayName;
      setLoungeGreeting(displayName);
      cacheDisplayName(currentUser.id, displayName);
    }

    function readCachedDisplayName(userId) {
      try {
        var cached = JSON.parse(localStorage.getItem(displayNameStorageKey) || "null");
        return cached && cached.userId === userId && typeof cached.displayName === "string"
          ? cached.displayName.trim()
          : "";
      } catch (_error) {
        return "";
      }
    }

    function cacheDisplayName(userId, displayName) {
      try {
        localStorage.setItem(displayNameStorageKey, JSON.stringify({
          userId: userId,
          displayName: String(displayName || "").trim()
        }));
      } catch (_error) {}
    }

    function setLoungeGreeting(displayName) {
      if (!el.loungeGreeting || !el.loungeLockin || !el.loungeLockinName) return;
      var name = String(displayName || "").trim();
      el.loungeGreeting.classList.toggle("is-personalized", Boolean(name));
      el.loungeLockin.hidden = !name;
      el.loungeLockinName.textContent = name;
    }

    async function uploadAvatar() {
      if (!currentUser || !el.avatarUpload.files.length) return;

      var file = el.avatarUpload.files[0];
      if (!file.type.match(/^image\/(png|jpeg|gif|webp)$/)) {
        el.accountStatus.textContent = "Use a PNG, JPG, GIF, or WebP avatar.";
        return;
      }

      var extension = file.name.split(".").pop() || "png";
      var path = currentUser.id + "/avatar-" + Date.now() + "." + extension;
      el.accountStatus.textContent = "Uploading avatar...";

      var upload = await db.storage.from("avatars").upload(path, file, {
        cacheControl: "3600",
        upsert: true
      });

      if (upload.error) {
        el.accountStatus.textContent = upload.error.message;
        return;
      }

      var publicData = db.storage.from("avatars").getPublicUrl(path).data;
      var avatarUrl = publicData.publicUrl;

      await db
        .from("profiles")
        .update({ avatar_url: avatarUrl, updated_at: new Date().toISOString() })
        .eq("id", currentUser.id);

      profileAvatarCache[currentUser.id] = avatarUrl;
      renderAvatar(avatarUrl);
      el.accountStatus.textContent = "Avatar updated.";
    }

    function renderAvatar(url) {
      el.avatarPreview.src = url || defaultAvatar(currentUser ? currentUser.id : "student");
      syncShopifyCustomerAvatar(url || "");
      Array.prototype.slice.call(el.avatarOptions.querySelectorAll(".mf-avatar-choice"))
        .forEach(function (button) {
          button.classList.toggle("active", button.getAttribute("data-avatar-url") === url);
        });
    }

    function syncShopifyCustomerAvatar(url) {
      var accountButton = document.querySelector(".account-button");
      if (!accountButton) return;
      var customerId = accountButton.getAttribute("data-mf-customer-id") || "";
      if (customerId) {
        try {
          if (url) localStorage.setItem("memoryfuelCustomerAvatar:" + customerId, url);
          else localStorage.removeItem("memoryfuelCustomerAvatar:" + customerId);
        } catch (_error) {}
      }
      window.dispatchEvent(new CustomEvent("memoryfuel:customer-avatar-updated", {
        detail: { customerId: customerId, avatarUrl: url }
      }));
    }

    function renderAvatarOptions() {
      var options = builtInAvatars();
      el.avatarOptions.innerHTML = "";

      var uploadLabel = document.createElement("label");
      uploadLabel.className = "mf-avatar-upload-option";
      uploadLabel.setAttribute("for", "mf-avatar-upload");
      uploadLabel.textContent = "Upload your own image";
      el.avatarOptions.appendChild(uploadLabel);

      options.forEach(function (avatar) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "mf-avatar-choice";
        button.setAttribute("aria-label", "Choose avatar " + avatar.label);
        button.setAttribute("data-avatar-url", avatar.url);
        button.textContent = avatar.icon;
        button.addEventListener("click", function () {
          chooseBuiltInAvatar(avatar.url);
        });
        el.avatarOptions.appendChild(button);
      });
    }

    function toggleAvatarOptions() {
      el.avatarOptions.hidden = !el.avatarOptions.hidden;
      el.toggleAvatar.textContent = el.avatarOptions.hidden ? "Upload avatar" : "Close avatar options";
    }

    async function chooseBuiltInAvatar(url) {
      if (!currentUser) return;

      await db
        .from("profiles")
        .update({ avatar_url: url, updated_at: new Date().toISOString() })
        .eq("id", currentUser.id);

      profileAvatarCache[currentUser.id] = url;
      renderAvatar(url);
      el.accountStatus.textContent = "Avatar updated.";
    }

    function builtInAvatars() {
      var avatars = [
        ["Brain", "#f0065f", "#fff4cf", "🧠"],
        ["Duck", "#ffc400", "#211704", "🦆"],
        ["Cat", "#8b5cf6", "#fff7ff", "🐱"],
        ["Dog", "#3b82f6", "#eef6ff", "🐶"],
        ["Book", "#21e071", "#04140a", "📚"],
        ["Fire", "#ff5a1f", "#fff4cf", "🔥"],
        ["Leaf", "#14b87a", "#f4fff8", "🍃"],
        ["Moon", "#1d4ed8", "#eff6ff", "🌙"],
        ["Coffee", "#7c3f1d", "#fff2df", "☕"],
        ["Rocket", "#ec4899", "#fff0f7", "🚀"]
      ];

      return avatars.map(function (item) {
        return {
          label: item[0],
          icon: item[3],
          url: avatarSvg(item[1], item[2], item[3])
        };
      });
    }

    function avatarSvg(background, color, icon) {
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><defs><radialGradient id="g" cx="30%" cy="20%" r="75%"><stop offset="0%" stop-color="#ffffff" stop-opacity="0.46"/><stop offset="100%" stop-color="' + background + '"/></radialGradient></defs><rect width="96" height="96" rx="48" fill="url(#g)"/><circle cx="72" cy="25" r="10" fill="#ffffff" opacity="0.22"/><text x="48" y="60" text-anchor="middle" font-family="Apple Color Emoji, Segoe UI Emoji, Arial" font-size="38" font-weight="900" fill="' + color + '">' + icon + '</text></svg>';
      return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
    }

    async function loadCustomerPerks() {
      if (!currentUser || !currentUser.email) return;

      var result = await db
        .from("customer_perks")
        .select("perk_level")
        .ilike("email", currentUser.email)
        .maybeSingle();

      var hasPerk = !result.error && Boolean(result.data);
      el.perkBadge.hidden = !hasPerk;
      if (hasPerk) {
        el.perkBadge.textContent = result.data.perk_level === "customer"
          ? "Memory Fuel customer"
          : "Memory Fuel " + result.data.perk_level;
      }
    }

    function prepareGentleChime() {
      if (!gentleChimeEnabled) return;
      var AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;

      if (!timerAudioContext) timerAudioContext = new AudioContextClass();
      if (timerAudioContext.state === "suspended") {
        timerAudioContext.resume().catch(function () {});
      }
    }

    function playGentleChime() {
      if (!gentleChimeEnabled || !timerAudioContext) return;

      var now = timerAudioContext.currentTime;
      var melody = [
        { frequency: 523.25, delay: 0, duration: 0.82 },
        { frequency: 659.25, delay: 0.34, duration: 0.9 }
      ];

      for (var repeat = 0; repeat < 3; repeat += 1) {
        melody.forEach(function (tone) {
          var oscillator = timerAudioContext.createOscillator();
          var gain = timerAudioContext.createGain();
          var startsAt = now + (repeat * 1.35) + tone.delay;
          var endsAt = startsAt + tone.duration;

          oscillator.type = "sine";
          oscillator.frequency.setValueAtTime(tone.frequency, startsAt);
          gain.gain.setValueAtTime(0.0001, startsAt);
          gain.gain.exponentialRampToValueAtTime(0.042, startsAt + 0.09);
          gain.gain.exponentialRampToValueAtTime(0.0001, endsAt);
          oscillator.connect(gain);
          gain.connect(timerAudioContext.destination);
          oscillator.start(startsAt);
          oscillator.stop(endsAt + 0.02);
        });
      }
    }

    function updateTimerRing(remaining) {
      var progress = timer.duration > 0 ? Math.max(0, Math.min(1, remaining / timer.duration)) : 0;
      el.timerRing.style.setProperty("--mf-timer-progress", (progress * 360) + "deg");
    }

    function animateTimerRing() {
      if (!timer.running) return;
      var elapsed = (Date.now() - timer.visualStartedAt) / 1000;
      updateTimerRing(Math.max(0, timer.visualStartRemaining - elapsed));
      timer.animationFrameId = window.requestAnimationFrame(animateTimerRing);
    }

    function startTimer() {
      if (timer.running || !currentUser) return;
      prepareGentleChime();
      timer.running = true;
      timer.lastTick = Date.now();
      timer.visualStartedAt = timer.lastTick;
      timer.visualStartRemaining = timer.remaining;
      currentSessionSeconds = 0;
      el.status.textContent = timer.mode === "focus"
        ? "Focus session running. Study time is saving every minute."
        : "Break running. Breaks do not count toward study time.";
      createStudySession();
      timer.tickId = window.setInterval(tick, 1000);
      window.cancelAnimationFrame(timer.animationFrameId);
      timer.animationFrameId = window.requestAnimationFrame(animateTimerRing);
      persistTimerState();
      updatePresenceMode();
    }

    function pauseTimer() {
      if (!timer.running) {
        persistTimerState();
        return;
      }
      timer.running = false;
      timer.lastTick = null;
      window.clearInterval(timer.tickId);
      window.cancelAnimationFrame(timer.animationFrameId);
      timer.animationFrameId = null;
      flushStudyTime();
      finishStudySession();
      persistTimerState();
      updatePresenceMode();
    }

    function resetTimer() {
      pauseTimer();
      timer.duration = timerDurations[timer.mode] * 60;
      timer.remaining = timer.duration;
      el.status.textContent = "Timer reset.";
      renderTimer();
      persistTimerState();
    }

    function getTimerStateKey() {
      return currentUser ? timerStateStorageKey + ":" + currentUser.id : "";
    }

    function persistTimerState() {
      var storageKey = getTimerStateKey();
      if (!storageKey) return;
      var remaining = timer.remaining;
      if (timer.running && timer.lastTick) {
        remaining = Math.max(0, remaining - Math.floor((Date.now() - timer.lastTick) / 1000));
      }
      try {
        localStorage.setItem(storageKey, JSON.stringify({
          version: 1,
          mode: timer.mode,
          duration: timer.duration,
          remaining: remaining,
          durations: timerDurations,
          pendingStudySeconds: timer.mode === "focus" ? saveBuffer + saveInFlight : 0,
          wasRunning: timer.running,
          savedAt: Date.now()
        }));
      } catch (_error) {}
    }

    function restoreTimerState() {
      if (!currentUser || timerRestoredForUser === currentUser.id) return;
      timerRestoredForUser = currentUser.id;
      var storageKey = getTimerStateKey();
      var saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(storageKey) || "null");
      } catch (_error) {}
      if (!saved || saved.version !== 1 || ["focus", "short", "long"].indexOf(saved.mode) < 0) {
        renderTimer();
        return;
      }

      ["focus", "short", "long"].forEach(function (mode) {
        var fallback = timerDurations[mode];
        var storedMinutes = saved.durations && Number(saved.durations[mode]);
        var maximum = mode === "focus" ? 180 : mode === "short" ? 60 : 90;
        timerDurations[mode] = Math.max(1, Math.min(maximum, storedMinutes || fallback));
      });
      timer.mode = saved.mode;
      timer.duration = Math.max(60, Number(saved.duration) || timerDurations[timer.mode] * 60);
      var restoredRemaining = Number(saved.remaining);
      timer.remaining = Number.isFinite(restoredRemaining)
        ? Math.max(0, Math.min(timer.duration, restoredRemaining))
        : timer.duration;
      timer.running = false;
      timer.lastTick = null;
      timer.visualStartedAt = null;
      timer.visualStartRemaining = timer.remaining;
      el.focusMinutes.value = timerDurations.focus;
      el.shortMinutes.value = timerDurations.short;
      el.longMinutes.value = timerDurations.long;
      el.modes.forEach(function (button) {
        button.classList.toggle("active", button.getAttribute("data-mode") === timer.mode);
      });
      renderTimer();
      el.status.textContent = saved.wasRunning
        ? "Your timer was restored and paused after the refresh."
        : "Your saved timer is ready to continue.";
      var pendingStudySeconds = Math.max(0, Number(saved.pendingStudySeconds) || 0);
      if (pendingStudySeconds > 0) {
        saved.pendingStudySeconds = 0;
        try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_error) {}
        saveBuffer += pendingStudySeconds;
        flushStudyTime().then(persistTimerState);
      }
      persistTimerState();
    }

    function getFullscreenElement() {
      return document.fullscreenElement || document.webkitFullscreenElement || null;
    }

    function syncTimerFullscreenArtwork() {
      var lounge = document.querySelector(".mf-study-lounge");
      if (!lounge) return;
      var artworkUrl = lounge.style.getPropertyValue("--mf-artwork-url") || window.getComputedStyle(lounge).getPropertyValue("--mf-artwork-url");
      if (artworkUrl) el.timerWidget.style.setProperty("--mf-fullscreen-artwork-url", artworkUrl.trim());
      var artworkFit = lounge.style.getPropertyValue("--mf-artwork-fit") || window.getComputedStyle(lounge).getPropertyValue("--mf-artwork-fit");
      if (artworkFit) el.timerWidget.style.setProperty("--mf-fullscreen-artwork-fit", artworkFit.trim());
    }

    function toggleTimerFullscreen() {
      var fullscreenElement = getFullscreenElement();
      var request = el.timerWidget.requestFullscreen || el.timerWidget.webkitRequestFullscreen;
      var exit = document.exitFullscreen || document.webkitExitFullscreen;

      if (el.timerWidget.classList.contains("mf-timer-focus-mode")) {
        el.timerWidget.classList.remove("mf-timer-focus-mode");
        document.documentElement.classList.remove("mf-timer-focus-active");
        syncTimerFullscreenButton();
        return;
      }

      if (fullscreenElement === el.timerWidget) {
        if (exit) exit.call(document);
        return;
      }

      syncTimerFullscreenArtwork();

      if (!request) {
        enterTimerFocusFallback();
        return;
      }

      var result = request.call(el.timerWidget);
      if (result && typeof result.catch === "function") {
        result.catch(function () {
          enterTimerFocusFallback();
        });
      }
    }

    function enterTimerFocusFallback() {
      el.timerWidget.classList.add("mf-timer-focus-mode");
      document.documentElement.classList.add("mf-timer-focus-active");
      syncTimerFullscreenButton();
    }

    function syncTimerFullscreenButton() {
      var isFullscreen = getFullscreenElement() === el.timerWidget || el.timerWidget.classList.contains("mf-timer-focus-mode");
      el.timerFullscreen.classList.toggle("is-fullscreen", isFullscreen);
      el.timerFullscreen.setAttribute("aria-label", isFullscreen ? "Exit fullscreen timer" : "Enter fullscreen timer");
      el.timerFullscreen.setAttribute("title", isFullscreen ? "Exit fullscreen timer" : "Enter fullscreen timer");
      if (!isFullscreen) {
        var artworkPanel = document.getElementById("mf-timer-artwork-panel");
        var artworkToggle = document.getElementById("mf-timer-artwork");
        if (artworkPanel) artworkPanel.hidden = true;
        if (artworkToggle) artworkToggle.setAttribute("aria-expanded", "false");
      }
    }

    function tick() {
      var now = Date.now();
      var elapsed = Math.max(1, Math.floor((now - timer.lastTick) / 1000));
      timer.lastTick = now;
      timer.remaining = Math.max(0, timer.remaining - elapsed);

      if (timer.mode === "focus") {
        saveBuffer += elapsed;
        currentSessionSeconds += elapsed;
        stats.todaySeconds += elapsed;
        stats.totalSeconds += elapsed;
        stats.streak = Math.max(stats.streak, 1);

        if (saveBuffer >= 60) {
          flushStudyTime();
        }
      }

      if (timer.remaining <= 0) {
        pauseTimer();
        playGentleChime();
        el.status.textContent = timer.mode === "focus"
          ? "Focus session complete. Nice work."
          : "Break complete. Ready for the next round.";
      }

      persistTimerState();

      renderTimer();
      renderStats();
    }

    async function createStudySession() {
      if (!currentUser || timer.mode !== "focus") return;

      var result = await db
        .from("study_sessions")
        .insert({
          user_id: currentUser.id,
          session_type: "focus",
          duration_seconds: 0
        })
        .select("id")
        .single();

      if (!result.error && result.data) {
        currentSessionId = result.data.id;
      }
    }

    async function finishStudySession() {
      if (!currentUser || !currentSessionId) return;

      await db
        .from("study_sessions")
        .update({
          ended_at: new Date().toISOString(),
          duration_seconds: currentSessionSeconds
        })
        .eq("id", currentSessionId);

      currentSessionId = null;
      currentSessionSeconds = 0;
    }

    async function flushStudyTime() {
      if (studyTimeFlushPromise) return studyTimeFlushPromise;
      if (!currentUser || saveBuffer <= 0) return;

      var seconds = saveBuffer;
      var userId = currentUser.id;
      saveBuffer = 0;
      saveInFlight += seconds;
      persistTimerState();

      studyTimeFlushPromise = (async function () {
        var today = new Date().toISOString().slice(0, 10);
        var existing = await db
          .from("daily_study")
          .select("total_seconds")
          .eq("user_id", userId)
          .eq("study_date", today)
          .maybeSingle();
        if (existing.error) throw existing.error;

        var currentTotal = existing.data ? existing.data.total_seconds : 0;
        var saved = await db
          .from("daily_study")
          .upsert({
            user_id: userId,
            study_date: today,
            total_seconds: currentTotal + seconds,
            updated_at: new Date().toISOString()
          }, { onConflict: "user_id,study_date" });
        if (saved.error) throw saved.error;

        saveInFlight = Math.max(0, saveInFlight - seconds);
        persistTimerState();
        await loadStats();
        await loadLeaderboard();
      })();

      try {
        await studyTimeFlushPromise;
      } catch (_error) {
        saveInFlight = Math.max(0, saveInFlight - seconds);
        saveBuffer += seconds;
        persistTimerState();
      } finally {
        studyTimeFlushPromise = null;
      }

      if (saveBuffer >= 60) flushStudyTime();
    }

    async function loadStats() {
      if (!currentUser) return;

      var today = new Date().toISOString().slice(0, 10);
      var rows = await db
        .from("daily_study")
        .select("study_date,total_seconds")
        .eq("user_id", currentUser.id)
        .order("study_date", { ascending: false })
        .limit(730);

      var data = rows.data || [];
      studyRows = data;
      stats.todaySeconds = data.filter(function (row) { return row.study_date === today; })
        .reduce(function (sum, row) { return sum + row.total_seconds; }, 0);
      stats.totalSeconds = data.reduce(function (sum, row) { return sum + row.total_seconds; }, 0);
      stats.streak = calculateStreak(data);
      renderStats();
      renderStudyProgress();
    }

    async function loadLeaderboard() {
      var fullView = Boolean(el.board.closest(".mf-is-quick-view-tool"));
      var firstRankIndex = fullView ? leaderboardPage * leaderboardPageSize : 0;
      var lastRankIndex = fullView ? firstRankIndex + leaderboardPageSize - 1 : 4;
      var query = db
        .from(activeLeaderboard)
        .select("display_name,total_seconds", { count: "exact" })
        .order("total_seconds", { ascending: false })
        .order("display_name", { ascending: true });
      var result = fullView
        ? await query.range(firstRankIndex, lastRankIndex)
        : await query.limit(5);

      var rows = result.data || [];
      el.board.innerHTML = "";
      el.board.start = firstRankIndex + 1;
      renderLeaderboardPagination(fullView, result.count || 0, rows.length);

      if (result.error) {
        var errorItem = document.createElement("li");
        errorItem.textContent = "Run the latest SQL setup to enable this leaderboard.";
        el.board.appendChild(errorItem);
        return;
      }

      if (!rows.length) {
        var empty = document.createElement("li");
        empty.textContent = "No study time yet today.";
        el.board.appendChild(empty);
        return;
      }

      rows.forEach(function (row) {
        var item = document.createElement("li");
        item.textContent = row.display_name + " - " + formatToday(row.total_seconds);
        el.board.appendChild(item);
      });
    }

    function renderLeaderboardPagination(fullView, total, visibleCount) {
      if (!el.boardPagination) return;
      el.boardPagination.hidden = !fullView;
      if (!fullView) return;

      var totalPages = Math.max(1, Math.ceil(total / leaderboardPageSize));
      if (leaderboardPage >= totalPages) leaderboardPage = totalPages - 1;
      var firstRank = leaderboardPage * leaderboardPageSize + 1;
      var lastRank = Math.min(firstRank + Math.max(visibleCount, 1) - 1, Math.max(total, firstRank));

      if (el.boardPage) {
        el.boardPage.innerHTML = "";
        for (var pageIndex = 0; pageIndex < totalPages; pageIndex += 1) {
          var option = document.createElement("option");
          var optionFirst = pageIndex * leaderboardPageSize + 1;
          var optionLast = Math.min((pageIndex + 1) * leaderboardPageSize, Math.max(total, leaderboardPageSize));
          option.value = String(pageIndex);
          option.textContent = optionFirst + "–" + optionLast;
          option.selected = pageIndex === leaderboardPage;
          el.boardPage.appendChild(option);
        }
      }
      if (el.boardPrev) el.boardPrev.disabled = leaderboardPage === 0;
      if (el.boardNext) el.boardNext.disabled = leaderboardPage >= totalPages - 1;
      if (el.boardRange) el.boardRange.textContent = total
        ? "Showing ranks " + firstRank + "–" + lastRank + " of " + total
        : "No ranked students yet";
    }

    async function loadChatMessages() {
      var result = await db
        .from("chat_messages")
        .select("id,user_id,message,media_url,media_type,created_at")
        .eq("room", chatRoom)
        .order("created_at", { ascending: false })
        .limit(30);

      el.chatMessages.innerHTML = "";

      if (result.error) {
        el.chatStatus.textContent = "Run the latest SQL setup to enable live chat.";
        return;
      }

      await hydrateProfileNames(result.data || []);
      updateUnreadFromLoadedMessages(result.data || []);
      (result.data || []).reverse().forEach(addChatMessage);
      scrollChatToBottom();
    }

    async function hydrateProfileNames(rows) {
      var ids = rows
        .map(function (row) { return row.user_id; })
        .filter(function (id, index, list) {
          return id && !profileNameCache[id] && list.indexOf(id) === index;
        });

      if (!ids.length) return;

      var result = await db
        .from("profiles")
        .select("id,display_name,avatar_url")
        .in("id", ids);

      (result.data || []).forEach(function (profile) {
        profileNameCache[profile.id] = profile.display_name || "Student";
        profileAvatarCache[profile.id] = profile.avatar_url || "";
      });
    }

    function setupChat() {
      if (chatChannel) return;

      chatChannel = db
        .channel("study-lounge-chat-" + chatRoom)
        .on("postgres_changes", {
          event: "INSERT",
          schema: "public",
          table: "chat_messages",
          filter: "room=eq." + chatRoom
        }, function (payload) {
          loadProfileName(payload.new.user_id);
          addChatMessage({
            id: payload.new.id,
            user_id: payload.new.user_id,
            message: payload.new.message,
            media_url: payload.new.media_url,
            media_type: payload.new.media_type,
            created_at: payload.new.created_at,
          });
          scrollChatToBottom();
          if (currentUser && payload.new.user_id !== currentUser.id) {
            if (el.lounge.classList.contains("mf-chat-drawer-open")) markChatMessagesRead();
            else updateChatUnreadBadge(chatUnreadCount + 1);
          }
        })
        .subscribe();
    }

    async function loadProfileName(userId) {
      if (!userId || profileNameCache[userId]) return;

      var result = await db
        .from("profiles")
        .select("display_name,avatar_url")
        .eq("id", userId)
        .maybeSingle();

      if (!result.error && result.data) {
        profileNameCache[userId] = result.data.display_name || "Student";
        profileAvatarCache[userId] = result.data.avatar_url || "";
        Array.prototype.slice.call(document.querySelectorAll('[data-chat-user="' + userId + '"] .mf-chat-name'))
          .forEach(function (name) {
            name.textContent = profileNameCache[userId];
          });
        Array.prototype.slice.call(document.querySelectorAll('[data-chat-user="' + userId + '"] .mf-chat-avatar'))
          .forEach(function (avatar) {
            avatar.src = profileAvatarCache[userId] || defaultAvatar(userId);
          });
      }
    }

    function getChatImageDetails(file) {
      if (!file) return null;

      var extension = (file.name.split(".").pop() || "").toLowerCase();
      var allowedExtensions = ["gif", "png", "jpg", "jpeg", "webp"];
      var allowedMimeTypes = ["image/gif", "image/png", "image/jpeg", "image/jpg", "image/webp"];
      var normalizedMime = (file.type || "").toLowerCase();

      if (allowedExtensions.indexOf(extension) === -1 || (normalizedMime && allowedMimeTypes.indexOf(normalizedMime) === -1)) {
        return null;
      }

      return {
        extension: extension === "jpeg" ? "jpg" : extension,
        mimeType: normalizedMime || (extension === "jpg" || extension === "jpeg" ? "image/jpeg" : "image/" + extension)
      };
    }

    function clearChatAttachment() {
      if (chatAttachmentObjectUrl) URL.revokeObjectURL(chatAttachmentObjectUrl);
      chatAttachmentObjectUrl = "";
      el.chatMedia.value = "";
      el.chatAttachmentPreview.removeAttribute("src");
      el.chatAttachmentName.textContent = "";
      el.chatAttachment.hidden = true;
    }

    function previewChatAttachment() {
      var file = el.chatMedia.files[0];
      if (!file) {
        clearChatAttachment();
        return;
      }

      if (!getChatImageDetails(file)) {
        clearChatAttachment();
        el.chatStatus.textContent = "Choose a GIF, PNG, JPG, or WebP image.";
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        clearChatAttachment();
        el.chatStatus.textContent = "Keep chat images under 5MB.";
        return;
      }

      if (chatAttachmentObjectUrl) URL.revokeObjectURL(chatAttachmentObjectUrl);
      chatAttachmentObjectUrl = URL.createObjectURL(file);
      el.chatAttachmentPreview.src = chatAttachmentObjectUrl;
      el.chatAttachmentName.textContent = file.name;
      el.chatAttachment.hidden = false;
      el.chatStatus.textContent = "Image ready to send.";
    }

    async function sendChatMessage() {
      if (!currentUser) return;

      var message = el.chatInput.value.trim();
      var mediaFile = el.chatMedia.files[0];
      var mediaUrl = "";
      var mediaType = "";
      var uploadedPath = "";

      if (!message && !mediaFile) return;

      if (hasBlockedChatLanguage(message)) {
        el.chatStatus.textContent = "Message blocked. Please keep the study room respectful.";
        return;
      }

      el.sendChat.disabled = true;
      el.chatStatus.textContent = mediaFile ? "Uploading..." : "Sending...";

      if (mediaFile) {
        var imageDetails = getChatImageDetails(mediaFile);
        if (!imageDetails) {
          el.chatStatus.textContent = "Use a GIF, PNG, JPG, or WebP file.";
          el.sendChat.disabled = false;
          return;
        }

        if (mediaFile.size > 5 * 1024 * 1024) {
          el.chatStatus.textContent = "Keep chat images under 5MB.";
          el.sendChat.disabled = false;
          return;
        }

        var path = currentUser.id + "/chat-" + Date.now() + "." + imageDetails.extension;
        var upload = await db.storage.from("chat-media").upload(path, mediaFile, {
          cacheControl: "3600",
          contentType: imageDetails.mimeType,
          upsert: false
        });

        if (upload.error) {
          var uploadError = String(upload.error.message || "").toLowerCase();
          el.chatStatus.textContent = uploadError.indexOf("row-level security") !== -1 || uploadError.indexOf("unauthorized") !== -1
            ? "Your image upload session expired. Sign out, sign back in, and try again."
            : "The image could not upload. Please try again.";
          el.sendChat.disabled = false;
          return;
        }

        mediaUrl = db.storage.from("chat-media").getPublicUrl(path).data.publicUrl;
        mediaType = imageDetails.mimeType;
        uploadedPath = path;
      }

      var result = await db
        .from("chat_messages")
        .insert({
          user_id: currentUser.id,
          room: chatRoom,
          message: message || null,
          media_url: mediaUrl || null,
          media_type: mediaType || null
        });

      el.sendChat.disabled = false;

      if (result.error) {
        if (uploadedPath) await db.storage.from("chat-media").remove([uploadedPath]);
        el.chatStatus.textContent = "The image could not be added to chat. Please try again.";
        return;
      }

      el.chatInput.value = "";
      clearChatAttachment();
      el.chatStatus.textContent = "Sent.";
    }

    function setChatDrawer(open, returnFocus) {
      if (!el.lounge || !el.console || !el.chatDrawerToggle) return;
      var shouldOpen = Boolean(open && currentUser && !el.console.hidden);
      el.lounge.classList.toggle("mf-chat-drawer-open", shouldOpen);
      el.chatDrawerToggle.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
      el.chatDrawerToggle.setAttribute("aria-label", shouldOpen ? "Close Study Room live chat" : "Open Study Room live chat");
      el.console.setAttribute("aria-hidden", shouldOpen ? "false" : "true");

      if (shouldOpen) {
        markChatMessagesRead();
        closeAccountPanel();
        var artworkPanel = document.getElementById("mf-artwork-panel");
        var artworkToggle = document.getElementById("mf-artwork-toggle");
        if (artworkPanel) artworkPanel.hidden = true;
        if (artworkToggle) artworkToggle.setAttribute("aria-expanded", "false");
        window.setTimeout(function () { el.chatInput.focus(); }, 120);
      } else if (returnFocus) {
        el.chatDrawerToggle.focus();
      }
    }

    function getChatReadStorageKey() {
      return currentUser ? chatUnreadStorageKey + ":" + currentUser.id + ":" + chatRoom : "";
    }

    function readChatLastReadAt() {
      var storageKey = getChatReadStorageKey();
      if (!storageKey) return 0;
      try { return Number(localStorage.getItem(storageKey)) || 0; } catch (_error) { return 0; }
    }

    function markChatMessagesRead() {
      var storageKey = getChatReadStorageKey();
      if (storageKey) {
        try { localStorage.setItem(storageKey, String(Date.now())); } catch (_error) {}
      }
      updateChatUnreadBadge(0);
    }

    function updateUnreadFromLoadedMessages(rows) {
      if (!currentUser || el.lounge.classList.contains("mf-chat-drawer-open")) {
        markChatMessagesRead();
        return;
      }
      var lastReadAt = readChatLastReadAt();
      if (!lastReadAt) {
        markChatMessagesRead();
        return;
      }
      var count = rows.filter(function (row) {
        return row.user_id !== currentUser.id && new Date(row.created_at).getTime() > lastReadAt;
      }).length;
      updateChatUnreadBadge(count);
    }

    function updateChatUnreadBadge(count) {
      chatUnreadCount = Math.max(0, Number(count) || 0);
      if (!el.chatUnreadBadge) return;
      el.chatUnreadBadge.textContent = chatUnreadCount > 99 ? "99+" : String(chatUnreadCount);
      el.chatUnreadBadge.hidden = chatUnreadCount === 0;
      el.chatUnreadBadge.setAttribute("aria-label", chatUnreadCount
        ? (chatUnreadCount > 99 ? "99 or more unread messages" : chatUnreadCount + " unread messages")
        : "No unread messages");
    }

    function toggleChatDrawer() {
      if (!currentUser) {
        closeAccountPanel();
        el.accountPanel.hidden = false;
        el.accountToggle.setAttribute("aria-expanded", "true");
        el.accountStatus.textContent = "Sign in to join the Study Room live chat.";
        window.setTimeout(function () { el.accountEmail.focus(); }, 0);
        return;
      }
      setChatDrawer(!el.lounge.classList.contains("mf-chat-drawer-open"), false);
    }

    function calmStartDayKey() {
      var now = new Date();
      return now.getFullYear() + "-" + String(now.getMonth() + 1).padStart(2, "0") + "-" + String(now.getDate()).padStart(2, "0");
    }

    function setupStudyCalendarTasks() {
      try {
        var storedTasks = JSON.parse(localStorage.getItem(calendarTaskStorageKey) || "{}");
        calendarTasks = storedTasks && typeof storedTasks === "object" ? storedTasks : {};
      } catch (error) {
        calendarTasks = {};
      }

      el.calendarAdd.addEventListener("click", function () {
        openCalendarDay(new Date(studyTracker.anchor));
      });
      el.calendarClose.addEventListener("click", closeCalendarDay);
      el.calendarDialog.querySelectorAll("[data-calendar-close]").forEach(function (node) {
        node.addEventListener("click", closeCalendarDay);
      });
      el.calendarTaskForm.addEventListener("submit", async function (event) {
        event.preventDefault();
        await addCalendarTask();
      });
      applyStatusSelectStyle(el.calendarTaskStatus);
      el.calendarTaskStatus.addEventListener("change", function () { applyStatusSelectStyle(el.calendarTaskStatus); });
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && !el.calendarDialog.hidden) closeCalendarDay();
      });
    }

    async function loadCalendarTasks() {
      if (!currentUser || calendarLoadedForUser === currentUser.id) return;

      await migrateLegacyCalendarTasks();
      var result = await db
        .from("schedule_events")
        .select("id,title,course,event_type,event_date,event_time,all_day,recurrence_rule,status,priority,source_kind,created_at")
        .eq("user_id", currentUser.id)
        .is("deleted_at", null)
        .order("event_date", { ascending: true })
        .order("created_at", { ascending: true })
        .limit(2500);

      if (result.error) {
        try {
          calendarTasks = JSON.parse(localStorage.getItem(calendarCacheKey()) || "{}");
        } catch (error) {
          calendarTasks = {};
        }
      } else {
        calendarTasks = {};
        (result.data || []).forEach(function (row) {
          var task = calendarRowToTask(row);
          if (!calendarTasks[row.event_date]) calendarTasks[row.event_date] = [];
          calendarTasks[row.event_date].push(task);
        });
        saveCalendarTasks();
      }

      calendarLoadedForUser = currentUser.id;
      renderStudyProgress();
      if (!el.calendarDialog.hidden) renderCalendarTaskList();
    }

    async function migrateLegacyCalendarTasks() {
      var markerKey = "memoryfuelStudyCalendarMigratedV2:" + currentUser.id;
      if (localStorage.getItem(markerKey) === "yes") return;

      var legacy = {};
      try {
        legacy = JSON.parse(localStorage.getItem(calendarTaskStorageKey) || "{}");
      } catch (error) {
        legacy = {};
      }

      var rows = [];
      Object.keys(legacy || {}).forEach(function (date) {
        (legacy[date] || []).forEach(function (task, index) {
          rows.push({
            user_id: currentUser.id,
            title: String(task.title || "Untitled task").slice(0, 160),
            course: "",
            event_type: "assignment",
            event_date: date,
            all_day: true,
            status: task.status || "todo",
            priority: task.priority || "medium",
            source_kind: "manual",
            client_reference: "legacy:" + date + ":" + String(task.id || index)
          });
        });
      });

      if (rows.length) {
        var migration = await db.from("schedule_events").upsert(rows, {
          onConflict: "user_id,client_reference",
          ignoreDuplicates: true
        });
        if (migration.error) return;
      }

      localStorage.setItem(markerKey, "yes");
      localStorage.removeItem(calendarTaskStorageKey);
    }

    function calendarRowToTask(row) {
      return {
        id: row.id,
        title: row.title,
        course: row.course || "",
        eventType: row.event_type || "assignment",
        time: row.event_time || "",
        allDay: row.all_day !== false,
        recurrenceRule: row.recurrence_rule || "",
        status: row.status || "todo",
        priority: row.priority || "medium",
        sourceKind: row.source_kind || "manual"
      };
    }

    function openCalendarDay(date) {
      selectedCalendarDate = new Date(date || new Date());
      selectedCalendarDate.setHours(12, 0, 0, 0);
      el.calendarDialog.hidden = false;
      document.body.style.overflow = "hidden";
      el.calendarDialogTitle.textContent = selectedCalendarDate.toLocaleDateString([], {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric"
      });
      renderCalendarTaskList();
      window.setTimeout(function () { el.calendarTaskTitle.focus(); }, 0);
    }

    function closeCalendarDay() {
      el.calendarDialog.hidden = true;
      document.body.style.removeProperty("overflow");
      el.calendarTaskForm.reset();
      el.calendarTaskStatus.value = "todo";
      applyStatusSelectStyle(el.calendarTaskStatus);
      el.calendarTaskPriority.value = "medium";
    }

    async function addCalendarTask() {
      var title = el.calendarTaskTitle.value.trim().slice(0, 160);
      if (!title) return;
      var key = getDateKey(selectedCalendarDate);
      if (!currentUser) return;

      var result = await db.from("schedule_events").insert({
        user_id: currentUser.id,
        title: title,
        course: "",
        event_type: "assignment",
        event_date: key,
        all_day: true,
        status: el.calendarTaskStatus.value,
        priority: el.calendarTaskPriority.value,
        source_kind: "manual"
      }).select("id,title,course,event_type,event_date,event_time,all_day,recurrence_rule,status,priority,source_kind,created_at").single();

      if (result.error) {
        el.calendarDialogSummary.textContent = "Could not save this task. Please try again.";
        return;
      }

      var tasks = calendarTasks[key] || [];
      tasks.push(calendarRowToTask(result.data));
      calendarTasks[key] = tasks;
      saveCalendarTasks();
      el.calendarTaskTitle.value = "";
      renderCalendarTaskList();
      renderStudyProgress();
    }

    function saveCalendarTasks() {
      if (!currentUser) return;
      localStorage.setItem(calendarCacheKey(), JSON.stringify(calendarTasks));
    }

    function calendarCacheKey() {
      return "memoryfuelStudyCalendarCacheV2:" + (currentUser ? currentUser.id : "guest");
    }

    function renderCalendarTaskList() {
      var key = getDateKey(selectedCalendarDate);
      var tasks = calendarTasks[key] || [];
      el.calendarTaskList.innerHTML = "";
      el.calendarDialogSummary.textContent = tasks.length
        ? tasks.length + (tasks.length === 1 ? " task scheduled" : " tasks scheduled")
        : "No tasks scheduled";

      if (!tasks.length) {
        var empty = document.createElement("div");
        empty.className = "mf-calendar-task-empty";
        empty.textContent = "No tasks for this day. Add one above when you are ready.";
        el.calendarTaskList.appendChild(empty);
        return;
      }

      tasks.forEach(function (task) {
        var item = document.createElement("div");
        var done = document.createElement("input");
        var body = document.createElement("div");
        var title = document.createElement("div");
        var meta = document.createElement("div");
        var status = document.createElement("select");
        var edit = document.createElement("button");
        var remove = document.createElement("button");

        item.className = "mf-calendar-task-item" + (task.status === "done" ? " is-done" : "");
        done.type = "checkbox";
        done.checked = task.status === "done";
        done.setAttribute("aria-label", "Mark " + task.title + " complete");
        title.className = "mf-calendar-task-title";
        title.textContent = task.title;
        meta.className = "mf-calendar-task-meta";
        var metaParts = [task.priority + " priority"];
        if (task.course) metaParts.push(task.course);
        if (!task.allDay && task.time) metaParts.push(task.time.slice(0, 5));
        if (task.sourceKind === "syllabus") metaParts.push("Smart Syllabus");
        meta.textContent = metaParts.join(" · ");
        [
          { value: "todo", label: "● To do" },
          { value: "progress", label: "● In progress" },
          { value: "done", label: "● Done" }
        ].forEach(function (optionData) {
          var option = document.createElement("option");
          option.value = optionData.value;
          option.textContent = optionData.label;
          status.appendChild(option);
        });
        status.value = task.status;
        status.className = "mf-status-select";
        applyStatusSelectStyle(status);
        status.setAttribute("aria-label", "Status for " + task.title);
        edit.type = "button";
        edit.className = "mf-calendar-task-edit";
        edit.textContent = "Edit";
        edit.setAttribute("aria-label", "Edit " + task.title);
        remove.type = "button";
        remove.textContent = "×";
        remove.setAttribute("aria-label", "Delete " + task.title);

        done.addEventListener("change", async function () {
          var previous = task.status;
          var next = done.checked ? "done" : "todo";
          var result = await db.from("schedule_events").update({ status: next }).eq("id", task.id);
          if (result.error) {
            done.checked = previous === "done";
            return;
          }
          task.status = next;
          saveCalendarTasks();
          renderCalendarTaskList();
          renderStudyProgress();
        });
        status.addEventListener("change", async function () {
          var previous = task.status;
          var next = status.value;
          applyStatusSelectStyle(status);
          var result = await db.from("schedule_events").update({ status: next }).eq("id", task.id);
          if (result.error) {
            status.value = previous;
            applyStatusSelectStyle(status);
            return;
          }
          task.status = next;
          saveCalendarTasks();
          renderCalendarTaskList();
          renderStudyProgress();
        });
        edit.addEventListener("click", function () { openCalendarTaskEditor(item, task, key); });
        title.addEventListener("click", function () { openCalendarTaskEditor(item, task, key); });
        remove.addEventListener("click", async function () {
          var result = await db.from("schedule_events").update({ deleted_at: new Date().toISOString() }).eq("id", task.id);
          if (result.error) return;
          calendarTasks[key] = tasks.filter(function (itemTask) { return itemTask.id !== task.id; });
          saveCalendarTasks();
          renderCalendarTaskList();
          renderStudyProgress();
        });

        body.appendChild(title);
        body.appendChild(meta);
        item.appendChild(done);
        item.appendChild(body);
        item.appendChild(status);
        item.appendChild(edit);
        item.appendChild(remove);
        el.calendarTaskList.appendChild(item);
      });
    }

    function applyStatusSelectStyle(select) {
      if (!select) return;
      select.classList.remove("is-todo", "is-progress", "is-done");
      select.classList.add("is-" + (select.value || "todo"));
    }

    function openCalendarTaskEditor(item, task, oldKey) {
      var form = document.createElement("form");
      var title = document.createElement("input");
      var course = document.createElement("input");
      var type = document.createElement("select");
      var date = document.createElement("input");
      var time = document.createElement("input");
      var allDay = document.createElement("input");
      var status = document.createElement("select");
      var priority = document.createElement("select");
      var recurrence = document.createElement("input");
      var actions = document.createElement("div");
      var cancel = document.createElement("button");
      var save = document.createElement("button");

      function field(labelText, control, className) {
        var label = document.createElement("label");
        var text = document.createElement("span");
        text.textContent = labelText;
        label.className = className || "";
        label.appendChild(text);
        label.appendChild(control);
        return label;
      }

      item.innerHTML = "";
      item.className = "mf-calendar-task-item is-editing";
      form.className = "mf-calendar-task-editor";
      title.type = "text"; title.maxLength = 160; title.required = true; title.value = task.title;
      course.type = "text"; course.maxLength = 120; course.value = task.course || "";
      [
        ["exam", "Exam"], ["final_exam", "Final exam"], ["quiz", "Quiz"], ["homework", "Homework"],
        ["assignment", "Assignment"], ["paper", "Paper"], ["project", "Project"], ["presentation", "Presentation"],
        ["lab", "Lab"], ["discussion_post", "Discussion post"], ["reading_deadline", "Reading deadline"],
        ["class_cancellation", "Class cancellation"], ["major_deadline", "Major deadline"], ["other", "Other"]
      ].forEach(function (data) { var option = document.createElement("option"); option.value = data[0]; option.textContent = data[1]; type.appendChild(option); });
      type.value = task.eventType || "assignment";
      date.type = "date"; date.required = true; date.value = oldKey;
      time.type = "time"; time.value = task.time ? String(task.time).slice(0, 5) : "";
      allDay.type = "checkbox"; allDay.checked = task.allDay !== false;
      [["todo", "● To do"], ["progress", "● In progress"], ["done", "● Done"]].forEach(function (data) { var option = document.createElement("option"); option.value = data[0]; option.textContent = data[1]; status.appendChild(option); });
      status.value = task.status; status.className = "mf-status-select"; applyStatusSelectStyle(status);
      [["high", "High"], ["medium", "Medium"], ["low", "Low"]].forEach(function (data) { var option = document.createElement("option"); option.value = data[0]; option.textContent = data[1]; priority.appendChild(option); });
      priority.value = task.priority || "medium";
      recurrence.type = "text"; recurrence.maxLength = 500; recurrence.value = task.recurrenceRule || ""; recurrence.placeholder = "Only when this task repeats";
      time.disabled = allDay.checked;
      allDay.addEventListener("change", function () { time.disabled = allDay.checked; if (allDay.checked) time.value = ""; });
      status.addEventListener("change", function () { applyStatusSelectStyle(status); });
      cancel.type = "button"; cancel.textContent = "Cancel";
      save.type = "submit"; save.textContent = "Save changes";
      actions.className = "mf-calendar-task-editor-actions";
      actions.appendChild(cancel); actions.appendChild(save);
      form.appendChild(field("Task title", title, "mf-editor-wide"));
      form.appendChild(field("Course", course, "mf-editor-wide"));
      form.appendChild(field("Type", type));
      form.appendChild(field("Date", date));
      form.appendChild(field("Time", time));
      var allDayLabel = field("All day", document.createElement("span"), "mf-editor-all-day");
      allDayLabel.lastChild.className = "mf-editor-all-day-control";
      allDayLabel.lastChild.appendChild(allDay); allDayLabel.lastChild.appendChild(document.createTextNode(" All-day event"));
      form.appendChild(allDayLabel);
      form.appendChild(field("Status", status));
      form.appendChild(field("Priority", priority));
      form.appendChild(field("Recurrence", recurrence, "mf-editor-wide"));
      form.appendChild(actions);
      item.appendChild(form);
      cancel.addEventListener("click", renderCalendarTaskList);
      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        var newKey = date.value;
        if (!title.value.trim() || !newKey) return;
        save.disabled = true;
        var result = await db.from("schedule_events").update({
          title: title.value.trim().slice(0, 160),
          course: course.value.trim().slice(0, 120),
          event_type: type.value,
          event_date: newKey,
          event_time: allDay.checked ? null : (time.value || null),
          all_day: allDay.checked,
          recurrence_rule: recurrence.value.trim() || null,
          status: status.value,
          priority: priority.value
        }).eq("id", task.id).eq("user_id", currentUser.id)
          .select("id,title,course,event_type,event_date,event_time,all_day,recurrence_rule,status,priority,source_kind,created_at").single();
        if (result.error) {
          save.disabled = false;
          el.calendarDialogSummary.textContent = "Could not save these changes. Please try again.";
          return;
        }
        calendarTasks[oldKey] = (calendarTasks[oldKey] || []).filter(function (candidate) { return candidate.id !== task.id; });
        if (!calendarTasks[newKey]) calendarTasks[newKey] = [];
        calendarTasks[newKey].push(calendarRowToTask(result.data));
        saveCalendarTasks();
        renderCalendarTaskList();
        renderStudyProgress();
      });
      window.setTimeout(function () { title.focus(); title.select(); }, 0);
    }

    function appendCalendarTaskBadges(content, date) {
      var tasks = calendarTasks[getDateKey(date)] || [];
      if (!tasks.length) return 0;
      var badges = document.createElement("span");
      badges.className = "mf-calendar-task-badges";
      badges.setAttribute("aria-label", tasks.length + (tasks.length === 1 ? " task" : " tasks"));
      tasks.slice(0, 3).forEach(function (task) {
        var entry = document.createElement("span");
        var dot = document.createElement("i");
        var title = document.createElement("span");
        entry.className = "mf-calendar-task-entry";
        dot.className = "mf-calendar-task-dot is-" + task.status;
        title.className = "mf-calendar-task-title-preview";
        title.textContent = task.title;
        entry.appendChild(dot);
        entry.appendChild(title);
        badges.appendChild(entry);
      });
      if (tasks.length > 3) {
        var more = document.createElement("span");
        more.className = "mf-calendar-task-more";
        more.textContent = "+" + (tasks.length - 3) + " more";
        more.title = "Open all " + tasks.length + " tasks";
        badges.appendChild(more);
      }
      content.appendChild(badges);
      return tasks.length;
    }

    function setupCalmStart() {
      if (!el.dailyFocusInput || !el.quickNotes) return;

      ["memoryfuelStudyLoungeLayoutV11", "memoryfuelStudyLoungeLayoutV10", "memoryfuelStudyLoungeLayoutV9", "memoryfuelStudyLoungeLayoutV8"].forEach(function (key) {
        localStorage.removeItem(key);
      });

      try {
        var stored = JSON.parse(localStorage.getItem(calmStartStorageKey) || "{}");
        if (stored.date === calmStartDayKey()) {
          calmStartState.focus = typeof stored.focus === "string" ? stored.focus : "";
          calmStartState.notes = typeof stored.notes === "string" ? stored.notes : "";
          calmStartState.goalMinutes = clampMinutes(stored.goalMinutes, 50, 10, 480);
        }
      } catch (error) {
        calmStartState.goalMinutes = 50;
      }

      calmStartState.date = calmStartDayKey();
      el.dailyFocusInput.value = calmStartState.focus;
      el.focusGoal.value = calmStartState.goalMinutes;
      el.quickNotes.value = calmStartState.notes;

      el.saveDailyFocus.addEventListener("click", function () {
        calmStartState.focus = el.dailyFocusInput.value.trim();
        saveCalmStart();
        renderCalmStartProgress();
        el.focusEncouragement.textContent = calmStartState.focus
          ? "Focus set. Start one session when you are ready."
          : "Choose one focus and begin when you are ready.";
      });

      el.dailyFocusInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") el.saveDailyFocus.click();
      });

      el.focusGoal.addEventListener("change", function () {
        calmStartState.goalMinutes = clampMinutes(el.focusGoal.value, 50, 10, 480);
        el.focusGoal.value = calmStartState.goalMinutes;
        saveCalmStart();
        renderCalmStartProgress();
      });

      var notesSaveTimer = null;
      el.quickNotes.addEventListener("input", function () {
        calmStartState.notes = el.quickNotes.value;
        el.notesStatus.textContent = "Saving...";
        window.clearTimeout(notesSaveTimer);
        notesSaveTimer = window.setTimeout(function () {
          saveCalmStart();
          el.notesStatus.textContent = "Saved on this device";
        }, 350);
      });

      renderCalmStartProgress();
    }

    function saveCalmStart() {
      calmStartState.date = calmStartDayKey();
      localStorage.setItem(calmStartStorageKey, JSON.stringify(calmStartState));
    }

    function renderCalmStartProgress() {
      if (!el.focusGoalSummary || !el.focusProgressBar) return;
      var focusedMinutes = Math.floor(stats.todaySeconds / 60);
      var goal = Math.max(10, calmStartState.goalMinutes || 50);
      var progress = Math.min(100, (focusedMinutes / goal) * 100);
      el.focusGoalSummary.textContent = focusedMinutes + " of " + goal + " min";
      el.focusProgressBar.style.width = progress + "%";

      if (progress >= 100) {
        el.focusEncouragement.textContent = "Daily goal complete. Everything else is a bonus.";
      } else if (focusedMinutes > 0 && calmStartState.focus) {
        el.focusEncouragement.textContent = calmStartState.focus + " · " + Math.max(0, goal - focusedMinutes) + " minutes to goal";
      }
    }

    function setupWidgetLayout() {
      var root = document.querySelector(".mf-study-lounge");
      if (!root) return;

      var toggleButton = root.querySelector('[data-layout-action="toggle"]');
      var resetButton = root.querySelector('[data-layout-action="reset"]');
      var storageKey = "memoryfuelStudyLoungeLayoutV11";
      var dragging = null;
      var resizing = null;
      var observerQueued = false;
      var sizeSteps = ["small", "medium", "large"];
      var sizeLabels = {
        small: "Small",
        medium: "Medium",
        large: "Large"
      };
      var defaultSizes = {
        quote: "large",
        "study-stream": "medium",
        leaderboard: "small",
        timer: "small",
        checklist: "small",
        "lounge-status": "small",
        login: "small",
        profile: "small",
        chat: "small",
        stats: "small",
        streak: "small",
        "study-hours": "small"
      };
      var defaultOrderRanks = {
        quote: 0,
        "study-stream": 10,
        "lounge-status": 11,
        login: 12,
        profile: 12,
        chat: 13,
        leaderboard: 20,
        timer: 21,
        checklist: 22,
        stats: 23,
        streak: 24,
        "study-hours": 25
      };

      function widgets() {
        return Array.prototype.slice.call(root.querySelectorAll("[data-mf-draggable-widget]"));
      }

      function visibleWidgets() {
        return widgets().filter(function (widget) {
          return widget.offsetParent !== null;
        });
      }

      function isCustomizableWidget(widget) {
        return Boolean(widget && widget.getAttribute("data-mf-widget-customizable") === "true");
      }

      function customizableWidgets() {
        return widgets().filter(isCustomizableWidget);
      }

      function ensureHandles() {
        widgets().forEach(function (widget) {
          if (!isCustomizableWidget(widget)) return;
          var children = Array.prototype.slice.call(widget.children);
          var hasHandle = children.some(function (child) {
            return child.classList && child.classList.contains("mf-widget-drag-handle");
          });
          var hasSizeControls = children.some(function (child) {
            return child.classList && child.classList.contains("mf-widget-size-controls");
          });
          var hasResizeHandle = children.some(function (child) {
            return child.classList && child.classList.contains("mf-widget-resize-handle");
          });
          var hasCloseBadge = children.some(function (child) {
            return child.classList && child.classList.contains("mf-widget-close-badge");
          });

          if (!hasCloseBadge) {
            var closeBadge = document.createElement("span");
            closeBadge.className = "mf-widget-close-badge";
            closeBadge.textContent = "×";
            closeBadge.setAttribute("aria-hidden", "true");
            widget.insertBefore(closeBadge, widget.firstChild);
          }

          if (!hasHandle) {
            var handle = document.createElement("button");
            var icon = document.createElement("span");
            var dot = document.createElement("span");
            var label = document.createElement("span");

            handle.type = "button";
            handle.className = "mf-widget-drag-handle";
            icon.className = "mf-widget-drag-icon";
            dot.className = "mf-widget-drag-dot";
            label.className = "mf-widget-drag-label";
            label.textContent = "Move";
            icon.setAttribute("aria-hidden", "true");
            icon.appendChild(dot);
            handle.appendChild(icon);
            handle.appendChild(label);
            handle.setAttribute("aria-label", "Move " + (widget.getAttribute("data-widget-name") || "widget"));
            handle.setAttribute("title", "Drag to move. Use arrow keys while customizing.");
            handle.addEventListener("pointerdown", function (event) {
              startDrag(event, widget);
            });
            handle.addEventListener("keydown", function (event) {
              moveWithKeyboard(event, widget);
            });
            widget.insertBefore(handle, widget.firstChild);
          }

          if (!hasSizeControls) {
            var sizeControls = document.createElement("div");
            sizeControls.className = "mf-widget-size-controls";
            sizeControls.setAttribute("aria-label", "Widget size");
            sizeSteps.forEach(function (size) {
              var button = document.createElement("button");
              button.type = "button";
              button.textContent = size.charAt(0).toUpperCase();
              button.setAttribute("aria-label", sizeLabels[size] + " " + (widget.getAttribute("data-widget-name") || "widget"));
              button.setAttribute("data-widget-size-choice", size);
              button.addEventListener("click", function (event) {
                setWidgetSize(event, widget, size);
              });
              sizeControls.appendChild(button);
            });
            widget.insertBefore(sizeControls, widget.firstChild);
          }

          if (!hasResizeHandle) {
            var resizeHandle = document.createElement("button");
            resizeHandle.type = "button";
            resizeHandle.className = "mf-widget-resize-handle";
            resizeHandle.setAttribute("aria-label", "Resize " + (widget.getAttribute("data-widget-name") || "widget"));
            resizeHandle.setAttribute("title", "Drag to resize");
            resizeHandle.addEventListener("pointerdown", function (event) {
              startResize(event, widget);
            });
            resizeHandle.addEventListener("keydown", function (event) {
              if (event.key === "Enter" || event.key === " ") {
                cycleWidgetSize(event, widget);
              }
            });
            widget.appendChild(resizeHandle);
          }

          setupLongPress(widget);
        });
        updateSizeControls();
      }

      function setupLongPress(widget) {
        if (!isCustomizableWidget(widget)) return;
        if (widget.getAttribute("data-mf-longpress-ready") === "true") return;
        widget.setAttribute("data-mf-longpress-ready", "true");

        var timer = null;
        var startX = 0;
        var startY = 0;
        var ignoreSelector = "button, a, input, textarea, select, iframe, .mf-widget-drag-handle, .mf-widget-size-controls, .mf-widget-resize-handle";

        function clearTimer() {
          if (timer) {
            window.clearTimeout(timer);
            timer = null;
          }
        }

        widget.addEventListener("pointerdown", function (event) {
          if (root.classList.contains("mf-layout-editing")) return;
          if (event.button !== undefined && event.button !== 0) return;
          if (event.target.closest && event.target.closest(ignoreSelector)) return;

          startX = event.clientX;
          startY = event.clientY;
          clearTimer();
          timer = window.setTimeout(function () {
            timer = null;
            if (!root.classList.contains("mf-layout-custom")) {
              captureLayout();
            }
            setEditing(true);
          }, 560);
        });

        widget.addEventListener("pointermove", function (event) {
          if (!timer) return;
          if (Math.hypot(event.clientX - startX, event.clientY - startY) > 9) {
            clearTimer();
          }
        });

        widget.addEventListener("pointerup", clearTimer);
        widget.addEventListener("pointercancel", clearTimer);
        widget.addEventListener("pointerleave", clearTimer);
      }

      function refreshHandlesAndLayout() {
        if (dragging) return;
        if (observerQueued) return;
        observerQueued = true;
        window.requestAnimationFrame(function () {
          observerQueued = false;
          ensureHandles();
          if (root.classList.contains("mf-layout-custom")) {
            applyLayout(readLayout());
          }
          setEditing(root.classList.contains("mf-layout-editing"));
        });
      }

      function readLayout() {
        try {
          var layout = JSON.parse(localStorage.getItem(storageKey) || "{}");
          return {
            order: Array.isArray(layout.order) ? layout.order : [],
            sizes: layout.sizes || {}
          };
        } catch (error) {
          return { order: [], sizes: {} };
        }
      }

      function writeLayout(layout) {
        localStorage.setItem(storageKey, JSON.stringify(layout));
      }

      function widgetKey(widget) {
        return widget.getAttribute("data-widget-id") || widget.getAttribute("data-widget-name") || "";
      }

      function defaultOrder() {
        return widgets().map(function (widget, index) {
          return {
            key: widgetKey(widget),
            rank: defaultOrderRanks[widgetKey(widget)] === undefined ? 100 + index : defaultOrderRanks[widgetKey(widget)],
            index: index
          };
        }).filter(function (item) {
          return Boolean(item.key);
        }).sort(function (a, b) {
          return a.rank - b.rank || a.index - b.index;
        }).map(function (item) {
          return item.key;
        });
      }

      function normalizeLayout(layout) {
        var known = defaultOrder();
        var seen = {};
        var order = [];

        (layout.order || []).forEach(function (key) {
          if (known.indexOf(key) !== -1 && !seen[key]) {
            order.push(key);
            seen[key] = true;
          }
        });

        known.forEach(function (key) {
          if (!seen[key]) order.push(key);
        });

        layout.order = order;
        layout.sizes = layout.sizes || {};
        known.forEach(function (key) {
          if (sizeSteps.indexOf(layout.sizes[key]) === -1) {
            layout.sizes[key] = defaultSizes[key] || "medium";
          }
        });

        return layout;
      }

      function captureLayout() {
        var layout = normalizeLayout({
          order: root.classList.contains("mf-layout-custom") ? visualOrder() : defaultOrder(),
          sizes: {}
        });
        writeLayout(layout);
        applyLayout(layout);
      }

      function visualOrder() {
        return visibleWidgets().map(function (widget) {
          var rect = widget.getBoundingClientRect();
          return {
            key: widgetKey(widget),
            top: rect.top,
            left: rect.left
          };
        }).sort(function (a, b) {
          if (Math.abs(a.top - b.top) > 12) return a.top - b.top;
          return a.left - b.left;
        }).map(function (item) {
          return item.key;
        }).filter(Boolean);
      }

      function applyLayout(layout) {
        layout = normalizeLayout(layout || readLayout());
        root.classList.add("mf-layout-custom");

        widgets().forEach(function (widget) {
          var key = widgetKey(widget);
          var order = layout.order.indexOf(key);
          var size = layout.sizes[key] || defaultSizes[key] || "medium";

          widget.style.setProperty("--mf-widget-order", order === -1 ? 0 : order);
          widget.setAttribute("data-mf-widget-size", size);
          widget.setAttribute("data-mf-widget-order", order === -1 ? 0 : order);
        });
        updateSizeControls(layout);
      }

      function saveAndApply(layout) {
        layout = normalizeLayout(layout);
        writeLayout(layout);
        animateWidgetPositions(function () {
          applyLayout(layout);
        });
      }

      function clearLayout() {
        localStorage.removeItem(storageKey);
        localStorage.removeItem("memoryfuelStudyLoungeLayoutV10");
        localStorage.removeItem("memoryfuelStudyLoungeLayoutV9");
        localStorage.removeItem("memoryfuelStudyLoungeLayoutV8");
        root.classList.remove("mf-layout-custom", "mf-layout-editing");
        root.querySelectorAll(".mf-widget-drag-placeholder").forEach(function (placeholder) {
          placeholder.remove();
        });
        root.style.removeProperty("--mf-widget-layout-height");
        widgets().forEach(function (widget) {
          widget.style.removeProperty("--mf-widget-z");
          widget.style.removeProperty("--mf-widget-order");
          widget.style.removeProperty("--mf-drag-x");
          widget.style.removeProperty("--mf-drag-y");
          widget.removeAttribute("data-mf-widget-order");
          widget.removeAttribute("data-mf-widget-size");
          widget.classList.remove("mf-is-dragging", "mf-is-reordering", "mf-is-resizing", "mf-widget-drop-target");
        });
        if (toggleButton) toggleButton.textContent = "Move widgets";
      }

      function setEditing(active) {
        root.classList.toggle("mf-layout-editing", active);
        if (toggleButton) {
          toggleButton.textContent = active ? "Done moving" : "Move widgets";
          toggleButton.setAttribute("aria-pressed", active ? "true" : "false");
        }

        customizableWidgets().forEach(function (widget) {
          var handle = widget.querySelector(".mf-widget-drag-handle");
          if (handle) handle.tabIndex = active ? 0 : -1;
        });
      }

      function updateSizeControls(layout) {
        layout = normalizeLayout(layout || readLayout());
        customizableWidgets().forEach(function (widget) {
          var key = widgetKey(widget);
          var currentSize = layout.sizes[key] || defaultSizes[key] || "medium";
          widget.querySelectorAll("[data-widget-size-choice]").forEach(function (button) {
            var active = button.getAttribute("data-widget-size-choice") === currentSize;
            button.setAttribute("aria-pressed", active ? "true" : "false");
          });
        });
      }

      function setWidgetSize(event, widget, size) {
        if (!root.classList.contains("mf-layout-editing")) return;
        if (!isCustomizableWidget(widget)) return;
        event.preventDefault();
        event.stopPropagation();

        if (!root.classList.contains("mf-layout-custom")) {
          captureLayout();
        }

        if (sizeSteps.indexOf(size) === -1) return;
        var key = widgetKey(widget);
        var layout = normalizeLayout(readLayout());
        layout.sizes[key] = size;
        saveAndApply(layout);
      }

      function startResize(event, widget) {
        if (!root.classList.contains("mf-layout-editing")) return;
        if (!isCustomizableWidget(widget)) return;
        event.preventDefault();
        event.stopPropagation();

        if (!root.classList.contains("mf-layout-custom")) {
          captureLayout();
        }

        var key = widgetKey(widget);
        var layout = normalizeLayout(readLayout());
        var currentSize = layout.sizes[key] || defaultSizes[key] || "medium";

        resizing = {
          widget: widget,
          key: key,
          startX: event.clientX,
          startY: event.clientY,
          startSize: currentSize,
          activeSize: currentSize
        };

        widget.classList.add("mf-is-resizing");
        if (event.currentTarget.setPointerCapture) {
          event.currentTarget.setPointerCapture(event.pointerId);
        }
        window.addEventListener("pointermove", resizeMove);
        window.addEventListener("pointerup", endResize, { once: true });
      }

      function resizeMove(event) {
        if (!resizing) return;
        var dx = event.clientX - resizing.startX;
        var dy = event.clientY - resizing.startY;
        var size = sizeFromDrag(resizing.startSize, dx + dy);
        if (size === resizing.activeSize) return;

        resizing.activeSize = size;
        var layout = normalizeLayout(readLayout());
        layout.sizes[resizing.key] = size;
        saveAndApply(layout);
      }

      function endResize() {
        if (!resizing) return;
        resizing.widget.classList.remove("mf-is-resizing");
        resizing = null;
        window.removeEventListener("pointermove", resizeMove);
      }

      function sizeFromDrag(startSize, delta) {
        var startIndex = Math.max(0, sizeSteps.indexOf(startSize));
        var threshold = 72;
        var nextIndex = startIndex;
        if (delta > threshold) nextIndex = Math.min(sizeSteps.length - 1, startIndex + 1);
        if (delta > threshold * 2) nextIndex = Math.min(sizeSteps.length - 1, startIndex + 2);
        if (delta < -threshold) nextIndex = Math.max(0, startIndex - 1);
        if (delta < -threshold * 2) nextIndex = Math.max(0, startIndex - 2);
        return sizeSteps[nextIndex] || "medium";
      }

      function startDrag(event, widget) {
        if (!root.classList.contains("mf-layout-editing")) return;
        if (!isCustomizableWidget(widget)) return;
        event.preventDefault();
        event.stopPropagation();

        var rect = widget.getBoundingClientRect();
        var originalSize = widget.getAttribute("data-mf-widget-size");

        if (!root.classList.contains("mf-layout-custom")) {
          captureLayout();
        }

        var key = widgetKey(widget);
        var layout = normalizeLayout(readLayout());
        applyLayout(layout);

        var computed = window.getComputedStyle(widget);
        var span = computed.getPropertyValue("--mf-widget-span").trim() || "6";
        var rows = computed.getPropertyValue("--mf-widget-rows").trim() || "5";
        root.querySelectorAll(".mf-widget-drag-placeholder").forEach(function (stalePlaceholder) {
          stalePlaceholder.remove();
        });
        var placeholder = document.createElement("div");
        placeholder.className = "mf-widget-drag-placeholder";
        placeholder.textContent = "Drop " + (widget.getAttribute("data-widget-name") || "widget") + " here";
        placeholder.setAttribute("aria-hidden", "true");
        placeholder.style.setProperty("--mf-widget-span", span);
        placeholder.style.setProperty("--mf-widget-rows", rows);
        placeholder.style.setProperty("--mf-widget-order", layout.order.indexOf(key));
        placeholder.style.gridColumn = "span " + span;
        placeholder.style.gridRow = "span " + rows;
        widget.parentNode.insertBefore(placeholder, widget.nextSibling);

        dragging = {
          widget: widget,
          key: key,
          placeholder: placeholder,
          originalSize: originalSize,
          startX: event.clientX,
          startY: event.clientY,
          targetKey: null,
          after: false,
          startOrder: layout.order.slice(),
          previewOrder: layout.order.slice()
        };

        if (originalSize === null) {
          widget.removeAttribute("data-mf-widget-size");
        }
        widget.style.setProperty("--mf-drag-top", rect.top + "px");
        widget.style.setProperty("--mf-drag-left", rect.left + "px");
        widget.style.setProperty("--mf-drag-width", rect.width + "px");
        widget.style.setProperty("--mf-drag-height", rect.height + "px");
        widgets().forEach(function (item) {
          item.classList.add("mf-is-reordering");
        });
        widget.classList.add("mf-is-dragging");
        widget.style.setProperty("--mf-drag-x", "0px");
        widget.style.setProperty("--mf-drag-y", "0px");
        if (event.currentTarget.setPointerCapture) {
          event.currentTarget.setPointerCapture(event.pointerId);
        }
        window.addEventListener("pointermove", dragMove);
        window.addEventListener("pointerup", endDrag, { once: true });
        window.addEventListener("pointercancel", endDrag, { once: true });
      }

      function dragMove(event) {
        if (!dragging) return;

        var dx = event.clientX - dragging.startX;
        var dy = event.clientY - dragging.startY;
        dragging.widget.style.setProperty("--mf-drag-x", dx + "px");
        dragging.widget.style.setProperty("--mf-drag-y", dy + "px");

        var target = widgetFromPoint(event.clientX, event.clientY, dragging.widget);
        if (!target) {
          dragging.targetKey = null;
          widgets().forEach(function (widget) {
            widget.classList.remove("mf-widget-drop-target");
          });
          return;
        }

        var targetKey = widgetKey(target);
        var rect = target.getBoundingClientRect();
        var verticalDistance = Math.abs(event.clientY - (rect.top + rect.height / 2));
        var after = event.clientY > rect.top + rect.height / 2;
        if (verticalDistance < rect.height * 0.28) {
          after = event.clientX > rect.left + rect.width / 2;
        }

        if (dragging.targetKey === targetKey && dragging.after === after) return;
        dragging.targetKey = targetKey;
        dragging.after = after;
        previewWidgetOrder(targetKey, after);

        widgets().forEach(function (widget) {
          widget.classList.toggle("mf-widget-drop-target", widget === target);
        });
      }

      function endDrag() {
        if (!dragging) return;
        var active = dragging;
        var layout = normalizeLayout(readLayout());

        if (active.previewOrder && active.previewOrder.length) {
          layout.order = active.previewOrder.slice();
          writeLayout(layout);
        }

        active.widget.style.removeProperty("--mf-drag-x");
        active.widget.style.removeProperty("--mf-drag-y");
        active.widget.style.removeProperty("--mf-drag-top");
        active.widget.style.removeProperty("--mf-drag-left");
        active.widget.style.removeProperty("--mf-drag-width");
        active.widget.style.removeProperty("--mf-drag-height");
        active.widget.classList.remove("mf-is-dragging");
        if (active.placeholder && active.placeholder.parentNode) {
          active.placeholder.parentNode.removeChild(active.placeholder);
        }
        root.querySelectorAll(".mf-widget-drag-placeholder").forEach(function (stalePlaceholder) {
          stalePlaceholder.remove();
        });
        dragging = null;
        widgets().forEach(function (widget) {
          widget.classList.remove("mf-widget-drop-target", "mf-is-reordering");
          widget.style.removeProperty("transition");
          widget.style.removeProperty("transform");
        });
        window.removeEventListener("pointermove", dragMove);
        window.removeEventListener("pointercancel", endDrag);
        applyLayout(readLayout());
      }

      function previewWidgetOrder(targetKey, after) {
        if (!dragging || !targetKey || dragging.key === targetKey) return;

        var order = dragging.previewOrder.slice();
        var slots = [];
        var movableOrder = [];
        order.forEach(function (key, index) {
          var orderWidget = widgets().find(function (item) {
            return widgetKey(item) === key;
          });
          if (isCustomizableWidget(orderWidget)) {
            slots.push(index);
            movableOrder.push(key);
          }
        });
        var from = movableOrder.indexOf(dragging.key);
        var to = movableOrder.indexOf(targetKey);
        if (from === -1 || to === -1) return;

        movableOrder.splice(from, 1);
        if (from < to) to -= 1;
        movableOrder.splice(after ? to + 1 : to, 0, dragging.key);
        slots.forEach(function (slot, index) {
          order[slot] = movableOrder[index];
        });

        if (order.join("|") === dragging.previewOrder.join("|")) return;
        dragging.previewOrder = order;

        animateWidgetPositions(function () {
          widgets().forEach(function (widget) {
            var orderIndex = order.indexOf(widgetKey(widget));
            widget.style.setProperty("--mf-widget-order", orderIndex === -1 ? 0 : orderIndex);
            widget.setAttribute("data-mf-widget-order", orderIndex === -1 ? 0 : orderIndex);
          });
          if (dragging && dragging.placeholder) {
            dragging.placeholder.style.setProperty("--mf-widget-order", order.indexOf(dragging.key));
          }
        });
      }

      function animateWidgetPositions(update) {
        if (!root.classList.contains("mf-layout-editing")) {
          update();
          return;
        }

        var before = new Map();
        visibleWidgets().forEach(function (widget) {
          if (dragging && widget === dragging.widget) return;
          before.set(widgetKey(widget), widget.getBoundingClientRect());
        });

        update();

        window.requestAnimationFrame(function () {
          visibleWidgets().forEach(function (widget) {
            if (dragging && widget === dragging.widget) return;
            var key = widgetKey(widget);
            var first = before.get(key);
            if (!first) return;
            var last = widget.getBoundingClientRect();
            var dx = first.left - last.left;
            var dy = first.top - last.top;
            if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return;

            widget.style.transition = "none";
            widget.style.transform = "translate3d(" + dx + "px, " + dy + "px, 0)";
            widget.getBoundingClientRect();
            window.requestAnimationFrame(function () {
              widget.style.transition = "transform 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)";
              widget.style.transform = "";
            });
          });
        });
      }

      function widgetFromPoint(x, y, activeWidget) {
        var node = document.elementFromPoint(x, y);
        while (node && node !== root) {
          if (node.hasAttribute && node.hasAttribute("data-mf-draggable-widget") && node !== activeWidget && isCustomizableWidget(node)) {
            return node;
          }
          node = node.parentElement;
        }
        return closestWidget(x, y, activeWidget);
      }

      function closestWidget(x, y, activeWidget) {
        var winner = null;
        var winnerDistance = Infinity;

        visibleWidgets().forEach(function (widget) {
          if (widget === activeWidget || !isCustomizableWidget(widget)) return;
          var rect = widget.getBoundingClientRect();
          var centerX = rect.left + rect.width / 2;
          var centerY = rect.top + rect.height / 2;
          var distance = Math.hypot(centerX - x, centerY - y);

          if (distance < winnerDistance) {
            winner = widget;
            winnerDistance = distance;
          }
        });

        return winner;
      }

      function cycleWidgetSize(event, widget) {
        if (!root.classList.contains("mf-layout-editing")) return;
        if (!isCustomizableWidget(widget)) return;
        event.preventDefault();

        if (!root.classList.contains("mf-layout-custom")) {
          captureLayout();
        }

        var key = widgetKey(widget);
        var layout = normalizeLayout(readLayout());
        var currentSize = layout.sizes[key] || defaultSizes[key] || "medium";
        var currentIndex = sizeSteps.indexOf(currentSize);
        var nextSize = sizeSteps[(currentIndex + 1) % sizeSteps.length] || "medium";

        setWidgetSize(event, widget, nextSize);
      }

      function moveWithKeyboard(event, widget) {
        if (!root.classList.contains("mf-layout-editing")) return;
        if (!isCustomizableWidget(widget)) return;
        if (["ArrowUp", "ArrowLeft", "ArrowDown", "ArrowRight", "Home", "End"].indexOf(event.key) === -1) return;

        event.preventDefault();
        if (!root.classList.contains("mf-layout-custom")) {
          captureLayout();
        }

        var key = widgetKey(widget);
        var layout = normalizeLayout(readLayout());
        var slots = [];
        var movableOrder = [];
        layout.order.forEach(function (orderKey, orderIndex) {
          var orderWidget = widgets().find(function (item) {
            return widgetKey(item) === orderKey;
          });
          if (isCustomizableWidget(orderWidget)) {
            slots.push(orderIndex);
            movableOrder.push(orderKey);
          }
        });
        var index = movableOrder.indexOf(key);
        if (index === -1) return;

        var nextIndex = index;
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") nextIndex = Math.max(0, index - 1);
        if (event.key === "ArrowDown" || event.key === "ArrowRight") nextIndex = Math.min(movableOrder.length - 1, index + 1);
        if (event.key === "Home") nextIndex = 0;
        if (event.key === "End") nextIndex = movableOrder.length - 1;

        if (nextIndex === index) return;
        movableOrder.splice(index, 1);
        movableOrder.splice(nextIndex, 0, key);
        slots.forEach(function (slot, slotIndex) {
          layout.order[slot] = movableOrder[slotIndex];
        });
        saveAndApply(layout);

        widget.scrollIntoView({ block: "nearest", behavior: "smooth" });
        var handle = widget.querySelector(".mf-widget-drag-handle");
        if (handle) handle.focus();
      }

      ensureHandles();
      setEditing(false);
      if (localStorage.getItem(storageKey)) {
        applyLayout(readLayout());
      }

      if ("MutationObserver" in window) {
        var layoutObserver = new MutationObserver(refreshHandlesAndLayout);
        layoutObserver.observe(root, {
          attributes: true,
          subtree: true,
          attributeFilter: ["hidden"]
        });
      }

      if (toggleButton) {
        toggleButton.addEventListener("click", function () {
          var active = !root.classList.contains("mf-layout-editing");
          setEditing(active);
        });
      }

      if (resetButton) {
        resetButton.addEventListener("click", function () {
          if (!window.confirm("Restore the original Study Lounge layout? Your timer, tasks, chat, and study history will not be erased.")) return;
          clearLayout();
          if (el.status) el.status.textContent = "Original widget layout restored.";
        });
      }

      window.addEventListener("resize", function () {
        if (root.classList.contains("mf-layout-custom")) {
          applyLayout(readLayout());
        }
      });
    }

    function addChatMessage(row) {
      if (document.querySelector('[data-chat-id="' + row.id + '"]')) return;

      var item = document.createElement("div");
      var topLine = document.createElement("div");
      var author = document.createElement("div");
      var avatar = document.createElement("img");
      var name = document.createElement("span");
      var report = document.createElement("button");
      var text = document.createElement("span");
      var meta = document.createElement("span");
      var displayName = profileNameCache[row.user_id] || "Student";

      item.className = "mf-chat-message";
      item.setAttribute("data-chat-id", row.id);
      item.setAttribute("data-chat-user", row.user_id);
      topLine.className = "mf-chat-topline";
      author.className = "mf-chat-author";
      avatar.className = "mf-chat-avatar";
      avatar.alt = "";
      avatar.src = profileAvatarCache[row.user_id] || defaultAvatar(row.user_id);
      name.className = "mf-chat-name";
      report.className = "mf-report-user";
      report.type = "button";
      report.textContent = "Report";
      text.className = "mf-chat-text";
      meta.className = "mf-chat-meta";
      name.textContent = displayName;
      text.textContent = row.message || "";
      meta.textContent = formatChatTime(row.created_at);
      report.addEventListener("click", function () {
        reportUser(row.user_id, row.id);
      });

      author.appendChild(avatar);
      author.appendChild(name);
      topLine.appendChild(author);
      if (!currentUser || row.user_id !== currentUser.id) {
        topLine.appendChild(report);
      }
      item.appendChild(topLine);
      if (row.message) item.appendChild(text);
      if (row.media_url) {
        var media = document.createElement("img");
        media.className = "mf-chat-media-img";
        media.alt = "Chat media";
        media.src = row.media_url;
        item.appendChild(media);
      }
      item.appendChild(meta);
      el.chatMessages.appendChild(item);

      while (el.chatMessages.children.length > 40) {
        el.chatMessages.removeChild(el.chatMessages.firstElementChild);
      }
    }

    async function reportUser(userId, messageId) {
      if (!currentUser || userId === currentUser.id) return;

      var reason = window.prompt("Why are you reporting this account?", "Bad language or inappropriate chat");
      if (!reason) return;

      el.chatStatus.textContent = "Sending report...";

      var result = await db.functions.invoke("send-report-email", {
        body: {
          reported_user_id: userId,
          chat_message_id: messageId,
          reason: reason.slice(0, 240)
        }
      });

      if (result.error) {
        result = await db
          .from("account_reports")
          .insert({
            reporter_id: currentUser.id,
            reported_user_id: userId,
            chat_message_id: messageId,
            reason: reason.slice(0, 240)
          });
      }

      el.chatStatus.textContent = result.error
        ? result.error.message
        : "Report sent to Memory Fuel support. Thank you for helping keep the lounge focused.";
    }

    function hasBlockedChatLanguage(message) {
      if (!message) return false;
      var normalized = message
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ß/g, "ss")
        .replace(/[@$!0]/g, function (match) {
          return ({ "@": "a", "$": "s", "!": "i", "0": "o" })[match] || match;
        });

      return MF_BLOCKED_CHAT_WORDS.some(function (word) {
        return new RegExp("(^|[^a-z])" + escapeRegExp(word) + "([^a-z]|$)", "i").test(normalized);
      });
    }

    function escapeRegExp(value) {
      return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function defaultAvatar(seed) {
      var label = ((seed || "MF").replace(/[^a-z0-9]/gi, "").slice(0, 2) || "MF").toUpperCase();
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96"><rect width="96" height="96" rx="48" fill="#f0065f"/><text x="48" y="57" text-anchor="middle" font-family="Arial" font-size="28" font-weight="800" fill="#fff4cf">' + label + '</text></svg>';
      return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
    }

    function scrollChatToBottom() {
      el.chatMessages.scrollTop = el.chatMessages.scrollHeight;
    }

    function setupPresence() {
      if (presenceChannel) return;

      presenceChannel = db.channel("study-lounge-main", {
        config: { presence: { key: currentUser.id } }
      });

      presenceChannel
        .on("presence", { event: "sync" }, function () {
          var state = presenceChannel.presenceState();
          var count = Object.keys(state).length;
          el.onlineCount.textContent = count + (count === 1 ? " student online" : " students online");
        })
        .subscribe(async function (status) {
          if (status === "SUBSCRIBED") {
            await presenceChannel.track(presencePayload());
          }
        });
    }

    function presencePayload() {
      return {
        user_id: currentUser.id,
        display_name: el.accountDisplayName.value.trim() || "Student",
        mode: timer.running ? timer.mode : "idle",
        online_at: new Date().toISOString()
      };
    }

    async function updatePresenceMode() {
      if (presenceChannel && currentUser) {
        await presenceChannel.track(presencePayload());
      }
    }

    function calculateStreak(rows) {
      var studiedDays = rows.reduce(function (set, row) {
        if (row.total_seconds > 0) set[row.study_date] = true;
        return set;
      }, {});

      var streak = 0;
      var date = new Date();

      for (var i = 0; i < 365; i += 1) {
        var key = date.toISOString().slice(0, 10);
        if (!studiedDays[key]) break;
        streak += 1;
        date.setDate(date.getDate() - 1);
      }

      return streak;
    }

    function renderTimer() {
      var minutes = Math.floor(timer.remaining / 60);
      var seconds = timer.remaining % 60;
      var modeLabel = getTimerModeLabel(timer.mode);
      el.time.textContent = pad(minutes) + ":" + pad(seconds);
      el.timerModeLabel.textContent = modeLabel;
      if (!timer.running) updateTimerRing(timer.remaining);
      el.timerRing.setAttribute(
        "aria-label",
        modeLabel + ": " + minutes + " minutes and " + seconds + " seconds remaining"
      );
    }

    function updateTimerDurations() {
      timerDurations.focus = clampMinutes(el.focusMinutes.value, 25, 1, 180);
      timerDurations.short = clampMinutes(el.shortMinutes.value, 5, 1, 60);
      timerDurations.long = clampMinutes(el.longMinutes.value, 15, 1, 90);

      el.focusMinutes.value = timerDurations.focus;
      el.shortMinutes.value = timerDurations.short;
      el.longMinutes.value = timerDurations.long;

      el.modes.forEach(function (button) {
        var mode = button.getAttribute("data-mode");
        button.setAttribute("data-minutes", String(timerDurations[mode]));
      });

      if (!timer.running) {
        timer.duration = timerDurations[timer.mode] * 60;
        timer.remaining = timer.duration;
        renderTimer();
        persistTimerState();
      }
    }

    function clampMinutes(value, fallback, min, max) {
      var number = parseInt(value, 10);
      if (!Number.isFinite(number)) return fallback;
      return Math.max(min, Math.min(max, number));
    }

    function getTimerModeLabel(mode) {
      if (mode === "short") return "Short break";
      if (mode === "long") return "Long break";
      return "Pomodoro";
    }

    function renderStats() {
      el.today.textContent = formatToday(stats.todaySeconds);
      el.total.textContent = formatTotal(stats.totalSeconds);
      var dailyGoalSeconds = Math.max(60, Number(calmStartState.goalMinutes || 50) * 60);
      var todayProgress = Math.min(100, (stats.todaySeconds / dailyGoalSeconds) * 100);
      var totalProgress = stats.totalSeconds > 0 ? (stats.totalSeconds % 3600) / 3600 * 100 : 0;
      el.today.parentElement.style.setProperty("--mf-stat-progress", todayProgress.toFixed(2) + "%");
      el.total.parentElement.style.setProperty("--mf-stat-progress", totalProgress.toFixed(2) + "%");
      renderCalmStartProgress();
    }

    function renderStudyProgress() {
      var rowsByDate = studyRows.reduce(function (map, row) {
        map[row.study_date] = row.total_seconds;
        return map;
      }, {});
      var weekDays = getRecentDays(7);
      var currentWeekDays = getWeekDays(studyTracker.anchor);
      var rangeItems = [];
      var summaryItems = [];
      var rangeTitle = "";
      var rangeLabel = "";

      var streakLevel = Math.min(7, Math.max(0, stats.streak));
      var streakPanel = el.streakDays.closest(".mf-streak-panel");
      if (streakPanel) streakPanel.setAttribute("data-streak-level", String(streakLevel));
      el.streakCount.textContent = stats.streak + (stats.streak === 1 ? " day" : " days");
      el.streakLabel.textContent = stats.streak > 0
        ? "You have studied " + stats.streak + (stats.streak === 1 ? " day" : " days") + " in a row."
        : "Start today to begin your streak.";
      el.streakProgress.style.width = Math.min(100, (stats.streak / 7) * 100) + "%";

      el.streakDots.innerHTML = "";
      var activeStreakStart = Math.max(0, weekDays.length - streakLevel);
      weekDays.forEach(function (day, dayIndex) {
        var dot = document.createElement("div");
        var marker = document.createElement("span");
        var label = document.createElement("small");
        var studied = (rowsByDate[day.key] || 0) > 0;
        var earnedLevel = studied && dayIndex >= activeStreakStart ? Math.min(7, dayIndex - activeStreakStart + 1) : 1;
        dot.className = "mf-streak-dot" + (studied ? " studied streak-level-" + earnedLevel : "");
        label.textContent = day.label;
        dot.appendChild(marker);
        dot.appendChild(label);
        el.streakDots.appendChild(dot);
      });

      if (studyTracker.view === "year") {
        rangeItems = getYearItems(studyTracker.anchor, rowsByDate);
        summaryItems = rangeItems;
        rangeTitle = String(studyTracker.anchor.getFullYear());
        rangeLabel = "Year view";
        renderYearTracker(rangeItems);
      } else if (studyTracker.view === "month") {
        rangeItems = getMonthItems(studyTracker.anchor, rowsByDate);
        summaryItems = rangeItems.days;
        rangeTitle = studyTracker.anchor.toLocaleDateString([], { month: "long", year: "numeric" });
        rangeLabel = "Month view";
        renderMonthTracker(rangeItems);
      } else {
        rangeItems = currentWeekDays.map(function (day) {
          return {
            key: day.key,
            label: day.label,
            dateLabel: day.date.toLocaleDateString([], { month: "short", day: "numeric" }),
            seconds: rowsByDate[day.key] || 0,
            date: day.date
          };
        });
        summaryItems = rangeItems;
        rangeTitle = formatWeekRange(currentWeekDays);
        rangeLabel = "Week view";
        renderWeekTracker(rangeItems);
      }

      updateStudySummary(summaryItems, rangeTitle, rangeLabel);
      renderUpcomingEvents();
    }

    function getRecentDays(count) {
      var days = [];
      for (var i = count - 1; i >= 0; i -= 1) {
        var date = new Date();
        date.setDate(date.getDate() - i);
        days.push({
          key: getDateKey(date),
          label: date.toLocaleDateString([], { weekday: "short" }).slice(0, 1)
        });
      }
      return days;
    }

    function moveStudyRange(direction) {
      var date = new Date(studyTracker.anchor);
      if (studyTracker.view === "year") {
        date.setFullYear(date.getFullYear() + direction);
      } else if (studyTracker.view === "month") {
        date.setMonth(date.getMonth() + direction);
      } else {
        date.setDate(date.getDate() + direction * 7);
      }
      studyTracker.anchor = date;
      renderStudyProgress();
    }

    function updateStudySummary(items, title, label) {
      var total = items.reduce(function (sum, item) { return sum + (item.seconds || 0); }, 0);
      var best = items.reduce(function (max, item) { return Math.max(max, item.seconds || 0); }, 0);
      var average = items.length ? Math.round(total / items.length) : 0;

      el.weekTotal.textContent = formatTotal(total);
      el.studyRangeTotal.textContent = formatTotal(total);
      el.studyRangeBest.textContent = formatToday(best);
      el.studyRangeAverage.textContent = formatToday(average);
      el.studyRangeTitle.textContent = title;
      el.studyRangeLabel.textContent = label;
    }

    function renderWeekTracker(items) {
      var maxSeconds = getMaxSeconds(items);
      el.hoursChart.className = "mf-hours-chart is-week";
      el.hoursChart.innerHTML = "";

      items.forEach(function (item) {
        el.hoursChart.appendChild(createStudyCard(item.label, item.dateLabel, item.seconds, maxSeconds, true, isSameDay(item.date, new Date()), function () {
          openCalendarDay(item.date);
        }, item.date));
      });
    }

    function renderMonthTracker(items) {
      var maxSeconds = getMaxSeconds(items.days);
      el.hoursChart.className = "mf-hours-chart is-month";
      el.hoursChart.innerHTML = "";

      var weekdays = document.createElement("div");
      weekdays.className = "mf-calendar-weekdays";
      ["S", "M", "T", "W", "T", "F", "S"].forEach(function (label) {
        var day = document.createElement("span");
        day.textContent = label;
        weekdays.appendChild(day);
      });
      el.hoursChart.appendChild(weekdays);

      for (var i = 0; i < items.offset; i += 1) {
        var blank = document.createElement("div");
        blank.className = "mf-calendar-blank";
        el.hoursChart.appendChild(blank);
      }

      items.days.forEach(function (item) {
        el.hoursChart.appendChild(createStudyCard(String(item.date.getDate()), item.date.toLocaleDateString([], { weekday: "short" }), item.seconds, maxSeconds, true, isSameDay(item.date, new Date()), function () {
          openCalendarDay(item.date);
        }, item.date));
      });

      var usedSlots = items.offset + items.days.length;
      var trailingSlots = (7 - (usedSlots % 7)) % 7;
      for (var j = 0; j < trailingSlots; j += 1) {
        var trailingBlank = document.createElement("div");
        trailingBlank.className = "mf-calendar-blank";
        trailingBlank.setAttribute("aria-hidden", "true");
        el.hoursChart.appendChild(trailingBlank);
      }
    }

    function renderYearTracker(items) {
      var maxSeconds = getMaxSeconds(items);
      el.hoursChart.className = "mf-hours-chart is-year";
      el.hoursChart.innerHTML = "";

      items.forEach(function (item) {
        el.hoursChart.appendChild(createStudyCard(item.label, item.dateLabel, item.seconds, maxSeconds, true, false, function () {
          studyTracker.view = "month";
          studyTracker.anchor = new Date(item.date);
          syncStudyTabs();
          renderStudyProgress();
        }, item.date));
      });
    }

    function createStudyCard(name, dateLabel, seconds, maxSeconds, clickable, isToday, onClick, date) {
      var card = document.createElement("div");
      var content = clickable ? document.createElement("button") : document.createElement("div");
      var nameEl = document.createElement("span");
      var dateEl = document.createElement("span");
      var timeEl = document.createElement("span");
      var bar = document.createElement("span");
      var fill = document.createElement("span");

      card.className = "mf-calendar-card" + (seconds > 0 ? " is-filled" : "") + (isToday ? " is-today" : "") + (date && isPastCalendarDay(date) ? " is-past" : "");
      content.className = "mf-calendar-content";
      if (clickable) content.type = "button";
      if (onClick) content.addEventListener("click", onClick);

      nameEl.className = "mf-calendar-name";
      dateEl.className = "mf-calendar-date";
      timeEl.className = "mf-calendar-time";
      bar.className = "mf-calendar-bar";

      nameEl.textContent = name;
      dateEl.textContent = dateLabel;
      timeEl.textContent = seconds > 0 ? formatToday(seconds) : "0m";
      fill.style.width = maxSeconds > 0 ? Math.max(8, Math.round((seconds / maxSeconds) * 100)) + "%" : "0%";

      bar.appendChild(fill);
      content.appendChild(nameEl);
      content.appendChild(dateEl);
      content.appendChild(timeEl);
      if (date) {
        card.setAttribute("data-calendar-date", getDateKey(date));
        if (appendCalendarTaskBadges(content, date)) card.classList.add("has-calendar-tasks");
      }
      content.appendChild(bar);
      card.appendChild(content);
      return card;
    }

    function isPastCalendarDay(date) {
      var day = new Date(date);
      var today = new Date();
      day.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      return day.getTime() < today.getTime();
    }

    function renderUpcomingEvents() {
      if (!el.calendarUpcomingList) return;
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var upcoming = [];
      Object.keys(calendarTasks).forEach(function (key) {
        var due = new Date(key + "T12:00:00");
        if (Number.isNaN(due.getTime()) || due.getTime() < today.getTime()) return;
        due.setHours(0, 0, 0, 0);
        (calendarTasks[key] || []).forEach(function (task) {
          if (task.status === "done") return;
          upcoming.push({ key: key, date: due, task: task });
        });
      });
      upcoming.sort(function (left, right) {
        var dateDifference = left.date.getTime() - right.date.getTime();
        if (dateDifference) return dateDifference;
        return String(left.task.time || "23:59").localeCompare(String(right.task.time || "23:59"));
      });
      upcoming = upcoming.slice(0, 5);
      el.calendarUpcomingList.innerHTML = "";
      el.calendarUpcomingSummary.textContent = upcoming.length ? "Next " + upcoming.length + (upcoming.length === 1 ? " deadline" : " deadlines") : "No future events yet";
      if (!upcoming.length) {
        var empty = document.createElement("span");
        empty.className = "mf-calendar-upcoming-empty";
        empty.textContent = "Add a task or import a syllabus to start your countdown.";
        el.calendarUpcomingList.appendChild(empty);
        return;
      }
      upcoming.forEach(function (entry) {
        var button = document.createElement("button");
        var dot = document.createElement("i");
        var name = document.createElement("span");
        var countdown = document.createElement("span");
        var days = Math.round((entry.date.getTime() - today.getTime()) / 86400000);
        button.type = "button";
        button.className = "mf-calendar-upcoming-item";
        button.title = entry.task.title + " · " + entry.date.toLocaleDateString([], { month: "short", day: "numeric", year: "numeric" });
        dot.className = "mf-calendar-upcoming-dot is-" + entry.task.status;
        name.className = "mf-calendar-upcoming-name";
        countdown.className = "mf-calendar-upcoming-countdown";
        name.textContent = entry.task.title;
        countdown.textContent = days === 0 ? "Due today" : days === 1 ? "Due tomorrow" : days + " days left";
        button.appendChild(dot);
        button.appendChild(name);
        button.appendChild(countdown);
        button.addEventListener("click", function () { openCalendarDay(entry.date); });
        el.calendarUpcomingList.appendChild(button);
      });
    }

    function getWeekDays(anchor) {
      var start = new Date(anchor);
      start.setHours(0, 0, 0, 0);
      start.setDate(start.getDate() - start.getDay());
      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var date = new Date(start);
        date.setDate(start.getDate() + i);
        days.push({
          key: getDateKey(date),
          label: date.toLocaleDateString([], { weekday: "short" }).slice(0, 3),
          date: date
        });
      }
      return days;
    }

    function getMonthItems(anchor, rowsByDate) {
      var first = new Date(anchor.getFullYear(), anchor.getMonth(), 1);
      var last = new Date(anchor.getFullYear(), anchor.getMonth() + 1, 0);
      var days = [];
      for (var day = 1; day <= last.getDate(); day += 1) {
        var date = new Date(anchor.getFullYear(), anchor.getMonth(), day);
        days.push({
          date: date,
          seconds: rowsByDate[getDateKey(date)] || 0
        });
      }
      return {
        offset: first.getDay(),
        days: days
      };
    }

    function getYearItems(anchor, rowsByDate) {
      var year = anchor.getFullYear();
      var items = [];
      for (var month = 0; month < 12; month += 1) {
        var seconds = 0;
        var last = new Date(year, month + 1, 0);
        for (var day = 1; day <= last.getDate(); day += 1) {
          var date = new Date(year, month, day);
          seconds += rowsByDate[getDateKey(date)] || 0;
        }
        var itemDate = new Date(year, month, 1);
        items.push({
          label: itemDate.toLocaleDateString([], { month: "short" }),
          dateLabel: formatToday(seconds),
          seconds: seconds,
          date: itemDate
        });
      }
      return items;
    }

    function syncStudyTabs() {
      el.studyTabs.forEach(function (tab) {
        tab.classList.toggle("active", tab.getAttribute("data-study-view") === studyTracker.view);
      });
    }

    function getMaxSeconds(items) {
      return items.reduce(function (max, item) {
        return Math.max(max, item.seconds || 0);
      }, 0);
    }

    function formatWeekRange(days) {
      var first = days[0].date;
      var last = days[days.length - 1].date;
      return first.toLocaleDateString([], { month: "short", day: "numeric" }) + " - " + last.toLocaleDateString([], { month: "short", day: "numeric" });
    }

    function getDateKey(date) {
      return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
    }

    function isSameDay(a, b) {
      return getDateKey(a) === getDateKey(b);
    }

    function getFlameClass(streak) {
      if (streak >= 3) return "flame-blue";
      if (streak === 2) return "flame-red";
      if (streak === 1) return "flame-yellow";
      return "flame-zero";
    }

    async function loadChecklist() {
      var raw = localStorage.getItem(checklistKey());
      try {
        checklistItems = raw ? JSON.parse(raw) : [];
      } catch (error) {
        checklistItems = [];
      }
      if (!currentUser) {
        renderChecklist();
        return;
      }

      var markerKey = "memoryFuelChecklistMigratedV1:" + currentUser.id;
      if (localStorage.getItem(markerKey) !== "yes" && checklistItems.length) {
        var legacyRows = checklistItems.slice(0, 200).map(function (item, index) {
          return {
            user_id: currentUser.id,
            text: String(item.text || "").trim().slice(0, 500),
            done: Boolean(item.done),
            source_kind: "manual",
            client_reference: "legacy:" + String(item.id || index).slice(0, 120)
          };
        }).filter(function (item) { return item.text; });
        if (legacyRows.length) {
          var migration = await db.from("checklist_tasks").upsert(legacyRows, {
            onConflict: "user_id,client_reference",
            ignoreDuplicates: true
          });
          if (!migration.error) localStorage.setItem(markerKey, "yes");
        } else {
          localStorage.setItem(markerKey, "yes");
        }
      }

      var result = await db.from("checklist_tasks")
        .select("id,text,done,priority,due_date,source_kind,created_at")
        .eq("user_id", currentUser.id)
        .is("deleted_at", null)
        .order("created_at", { ascending: true });
      if (!result.error) {
        checklistItems = result.data || [];
        saveChecklist();
      }
      renderChecklist();
    }

    function saveChecklist() {
      localStorage.setItem(checklistKey(), JSON.stringify(checklistItems));
    }

    function checklistKey() {
      return "memoryFuelChecklist:" + (currentUser ? currentUser.id : "guest");
    }

    async function addChecklistTask() {
      var text = el.taskInput.value.trim();
      if (!text) return;
      el.taskInput.value = "";
      if (currentUser) {
        var result = await db.from("checklist_tasks").insert({
          user_id: currentUser.id,
          text: text.slice(0, 500),
          done: false,
          source_kind: "manual"
        }).select("id,text,done,priority,due_date,source_kind,created_at").single();
        if (!result.error && result.data) checklistItems.push(result.data);
        else el.status.textContent = "That checklist task could not be saved. Please try again.";
      } else {
        checklistItems.push({ id: String(Date.now()), text: text, done: false });
      }
      saveChecklist();
      renderChecklist();
    }

    async function toggleChecklistTask(id) {
      var nextDone = false;
      checklistItems = checklistItems.map(function (item) {
        if (item.id === id) {
          item.done = !item.done;
          nextDone = item.done;
        }
        return item;
      });
      saveChecklist();
      renderChecklist();
      if (currentUser) {
        var result = await db.from("checklist_tasks").update({ done: nextDone })
          .eq("id", id).eq("user_id", currentUser.id);
        if (result.error) await loadChecklist();
      }
    }

    async function deleteChecklistTask(id) {
      checklistItems = checklistItems.filter(function (item) {
        return item.id !== id;
      });
      saveChecklist();
      renderChecklist();
      if (currentUser) {
        var result = await db.from("checklist_tasks").update({ deleted_at: new Date().toISOString() })
          .eq("id", id).eq("user_id", currentUser.id);
        if (result.error) await loadChecklist();
      }
    }

    async function clearDoneTasks() {
      var doneIds = checklistItems.filter(function (item) { return item.done; }).map(function (item) { return item.id; });
      checklistItems = checklistItems.filter(function (item) {
        return !item.done;
      });
      saveChecklist();
      renderChecklist();
      if (currentUser && doneIds.length) {
        var result = await db.from("checklist_tasks").update({ deleted_at: new Date().toISOString() })
          .in("id", doneIds).eq("user_id", currentUser.id);
        if (result.error) await loadChecklist();
      }
    }

    function renderChecklist() {
      var doneCount = checklistItems.filter(function (item) { return item.done; }).length;
      el.checklistCount.textContent = doneCount + " of " + checklistItems.length + " done";
      el.taskList.innerHTML = "";

      if (!checklistItems.length) {
        var empty = document.createElement("li");
        empty.className = "mf-task-empty";
        empty.textContent = "Add your first focus task.";
        el.taskList.appendChild(empty);
        return;
      }

      checklistItems.forEach(function (task) {
        var item = document.createElement("li");
        var checkboxLabel = document.createElement("label");
        var checkbox = document.createElement("input");
        var checkboxMark = document.createElement("span");
        var text = document.createElement("span");
        var remove = document.createElement("button");

        item.className = "mf-task-item" + (task.done ? " done" : "");
        checkboxLabel.className = "mf-task-check";
        checkbox.type = "checkbox";
        checkbox.checked = task.done;
        checkbox.setAttribute("aria-label", (task.done ? "Mark incomplete: " : "Mark complete: ") + task.text);
        checkbox.addEventListener("change", function () {
          toggleChecklistTask(task.id);
        });
        checkboxMark.className = "mf-task-check-mark";
        checkboxMark.setAttribute("aria-hidden", "true");
        text.className = "mf-task-text";
        text.textContent = task.text;
        remove.className = "mf-task-delete";
        remove.type = "button";
        remove.textContent = "x";
        remove.setAttribute("aria-label", "Delete task");
        remove.addEventListener("click", function () {
          deleteChecklistTask(task.id);
        });

        checkboxLabel.appendChild(checkbox);
        checkboxLabel.appendChild(checkboxMark);
        item.appendChild(checkboxLabel);
        item.appendChild(text);
        item.appendChild(remove);
        el.taskList.appendChild(item);
      });
    }

    function pad(value) {
      return String(value).padStart(2, "0");
    }

    function formatToday(seconds) {
      return Math.floor(seconds / 60) + "m";
    }

    function formatTotal(seconds) {
      var hours = seconds / 3600;
      return hours < 10 ? hours.toFixed(1) + "h" : Math.floor(hours) + "h";
    }

    function formatChatTime(value) {
      var date = new Date(value);
      return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
    }

    function renderDailyQuote() {
      var quotes = buildDailyQuotes();
      var quoteText = document.getElementById("mf-daily-quote");
      var quoteAuthor = document.getElementById("mf-daily-quote-author");
      var quotePortrait = document.getElementById("mf-daily-quote-portrait");
      var quoteFallback = document.getElementById("mf-daily-quote-fallback");
      var start = new Date(new Date().getFullYear(), 0, 0);
      var today = new Date();
      var day = Math.floor((today - start) / 86400000);
      var quote = quotes[day % quotes.length];
      var portrait = (window.MF_QUOTE_PORTRAITS || {})[quote.author];

      if (quoteText) quoteText.textContent = '"' + quote.text + '"';
      if (quoteAuthor) quoteAuthor.textContent = "- " + quote.author;
      if (!quotePortrait || !quoteFallback) return;

      quoteFallback.textContent = quote.author.split(/\s+/).map(function (part) { return part.charAt(0); }).slice(0, 2).join("");
      if (!portrait) {
        quotePortrait.hidden = true;
        quoteFallback.hidden = false;
        return;
      }

      quotePortrait.alt = "Portrait of " + quote.author;
      quotePortrait.hidden = false;
      quoteFallback.hidden = true;
      quotePortrait.src = portrait.image;
      quotePortrait.onerror = function () {
        quotePortrait.hidden = true;
        quoteFallback.hidden = false;
      };
    }

    function buildDailyQuotes() {
      if (Array.isArray(window.MF_DAILY_QUOTES) && window.MF_DAILY_QUOTES.length === 366) {
        return window.MF_DAILY_QUOTES;
      }
      return [
        { text: "The secret of getting ahead is getting started.", author: "Mark Twain" },
        { text: "It always seems impossible until it is done.", author: "Nelson Mandela" },
        { text: "Well done is better than well said.", author: "Benjamin Franklin" },
        { text: "Energy and persistence conquer all things.", author: "Benjamin Franklin" },
        { text: "Action is the foundational key to all success.", author: "Pablo Picasso" },
        { text: "The future depends on what you do today.", author: "Mahatma Gandhi" },
        { text: "Learning never exhausts the mind.", author: "Leonardo da Vinci" },
        { text: "Genius is one percent inspiration and ninety-nine percent perspiration.", author: "Thomas Edison" },
        { text: "The expert in anything was once a beginner.", author: "Helen Hayes" },
        { text: "An investment in knowledge pays the best interest.", author: "Benjamin Franklin" },
        { text: "Knowledge is power.", author: "Francis Bacon" },
        { text: "The roots of education are bitter, but the fruit is sweet.", author: "Aristotle" },
        { text: "Education is the kindling of a flame, not the filling of a vessel.", author: "Socrates" },
        { text: "The only true wisdom is in knowing you know nothing.", author: "Socrates" },
        { text: "He who opens a school door, closes a prison.", author: "Victor Hugo" },
        { text: "The journey of a thousand miles begins with one step.", author: "Lao Tzu" },
        { text: "Do what you can, with what you have, where you are.", author: "Theodore Roosevelt" },
        { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
        { text: "Act as if what you do makes a difference. It does.", author: "William James" },
        { text: "To improve is to change; to be perfect is to change often.", author: "Winston Churchill" },
        { text: "Success is stumbling from failure to failure with no loss of enthusiasm.", author: "Winston Churchill" },
        { text: "Continuous effort, not strength or intelligence, is the key to unlocking our potential.", author: "Winston Churchill" },
        { text: "The way to get started is to quit talking and begin doing.", author: "Walt Disney" },
        { text: "All our dreams can come true, if we have the courage to pursue them.", author: "Walt Disney" },
        { text: "The best way out is always through.", author: "Robert Frost" },
        { text: "In the middle of difficulty lies opportunity.", author: "Albert Einstein" },
        { text: "Imagination is more important than knowledge.", author: "Albert Einstein" },
        { text: "Life is like riding a bicycle. To keep your balance, you must keep moving.", author: "Albert Einstein" },
        { text: "I have no special talent. I am only passionately curious.", author: "Albert Einstein" },
        { text: "Once you stop learning, you start dying.", author: "Albert Einstein" },
        { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
        { text: "We are what we repeatedly do.", author: "Aristotle" },
        { text: "Knowing yourself is the beginning of all wisdom.", author: "Aristotle" },
        { text: "Pleasure in the job puts perfection in the work.", author: "Aristotle" },
        { text: "It does not matter how slowly you go as long as you do not stop.", author: "Confucius" },
        { text: "Our greatest glory is not in never falling, but in rising every time we fall.", author: "Confucius" },
        { text: "Real knowledge is to know the extent of one's ignorance.", author: "Confucius" },
        { text: "Study the past if you would define the future.", author: "Confucius" },
        { text: "Wherever you go, go with all your heart.", author: "Confucius" },
        { text: "What we learn with pleasure we never forget.", author: "Alfred Mercier" },
        { text: "The beautiful thing about learning is that nobody can take it away from you.", author: "B. B. King" },
        { text: "Preparation is the key to success.", author: "Alexander Graham Bell" },
        { text: "Before anything else, preparation is the key to success.", author: "Alexander Graham Bell" },
        { text: "A person who never made a mistake never tried anything new.", author: "Albert Einstein" },
        { text: "Try not to become a person of success, but rather a person of value.", author: "Albert Einstein" },
        { text: "The mind is not a vessel to be filled, but a fire to be kindled.", author: "Plutarch" },
        { text: "No great thing is created suddenly.", author: "Epictetus" },
        { text: "First say to yourself what you would be; then do what you have to do.", author: "Epictetus" },
        { text: "If you want to improve, be content to be thought foolish and stupid.", author: "Epictetus" },
        { text: "Waste no more time arguing what a good person should be. Be one.", author: "Marcus Aurelius" },
        { text: "The impediment to action advances action.", author: "Marcus Aurelius" },
        { text: "You have power over your mind, not outside events.", author: "Marcus Aurelius" },
        { text: "Begin at once to live, and count each separate day as a separate life.", author: "Seneca" },
        { text: "Luck is what happens when preparation meets opportunity.", author: "Seneca" },
        { text: "Difficulties strengthen the mind, as labor does the body.", author: "Seneca" },
        { text: "No pressure, no diamonds.", author: "Thomas Carlyle" },
        { text: "Go as far as you can see; when you get there, you'll see further.", author: "Thomas Carlyle" },
        { text: "Nothing will work unless you do.", author: "Maya Angelou" },
        { text: "Do the best you can until you know better.", author: "Maya Angelou" },
        { text: "When you know better, do better.", author: "Maya Angelou" },
        { text: "Success is liking yourself, liking what you do, and liking how you do it.", author: "Maya Angelou" },
        { text: "If there is no struggle, there is no progress.", author: "Frederick Douglass" },
        { text: "Without a struggle, there can be no progress.", author: "Frederick Douglass" },
        { text: "I prayed for twenty years but received no answer until I prayed with my legs.", author: "Frederick Douglass" },
        { text: "You are your best thing.", author: "Toni Morrison" },
        { text: "Freeing yourself was one thing; claiming ownership of that freed self was another.", author: "Toni Morrison" },
        { text: "The function of freedom is to free someone else.", author: "Toni Morrison" },
        { text: "I am deliberate and afraid of nothing.", author: "Audre Lorde" },
        { text: "When I dare to be powerful, to use my strength, then fear becomes less important.", author: "Audre Lorde" },
        { text: "The most common way people give up their power is by thinking they don't have any.", author: "Alice Walker" },
        { text: "Hard times require furious dancing.", author: "Alice Walker" },
        { text: "No person is your friend who demands your silence.", author: "Alice Walker" },
        { text: "The question isn't who's going to let me; it's who's going to stop me.", author: "Ayn Rand" },
        { text: "The only limit to our realization of tomorrow is our doubts of today.", author: "Franklin D. Roosevelt" },
        { text: "Happiness lies in the joy of achievement.", author: "Franklin D. Roosevelt" },
        { text: "The only thing we have to fear is fear itself.", author: "Franklin D. Roosevelt" },
        { text: "You must do the thing you think you cannot do.", author: "Eleanor Roosevelt" },
        { text: "The future belongs to those who believe in the beauty of their dreams.", author: "Eleanor Roosevelt" },
        { text: "No one can make you feel inferior without your consent.", author: "Eleanor Roosevelt" },
        { text: "It takes as much energy to wish as it does to plan.", author: "Eleanor Roosevelt" },
        { text: "Do one thing every day that scares you.", author: "Eleanor Roosevelt" },
        { text: "The most effective way to do it, is to do it.", author: "Amelia Earhart" },
        { text: "Courage is the price that life exacts for granting peace.", author: "Amelia Earhart" },
        { text: "Never interrupt someone doing what you said couldn't be done.", author: "Amelia Earhart" },
        { text: "I dwell in possibility.", author: "Emily Dickinson" },
        { text: "Forever is composed of nows.", author: "Emily Dickinson" },
        { text: "Hope is the thing with feathers.", author: "Emily Dickinson" },
        { text: "That it will never come again is what makes life so sweet.", author: "Emily Dickinson" },
        { text: "What you do speaks so loudly that I cannot hear what you say.", author: "Ralph Waldo Emerson" },
        { text: "Once you make a decision, the universe conspires to make it happen.", author: "Ralph Waldo Emerson" },
        { text: "Nothing great was ever achieved without enthusiasm.", author: "Ralph Waldo Emerson" },
        { text: "Always do what you are afraid to do.", author: "Ralph Waldo Emerson" },
        { text: "The only way to have a friend is to be one.", author: "Ralph Waldo Emerson" },
        { text: "Go confidently in the direction of your dreams.", author: "Henry David Thoreau" },
        { text: "What you get by achieving your goals is not as important as what you become.", author: "Henry David Thoreau" },
        { text: "Success usually comes to those who are too busy to be looking for it.", author: "Henry David Thoreau" },
        { text: "Not all those who wander are lost.", author: "J. R. R. Tolkien" },
        { text: "Courage is found in unlikely places.", author: "J. R. R. Tolkien" },
        { text: "Little by little, one travels far.", author: "J. R. R. Tolkien" },
        { text: "It is our choices that show what we truly are.", author: "J. K. Rowling" },
        { text: "Rock bottom became the solid foundation on which I rebuilt my life.", author: "J. K. Rowling" },
        { text: "We do not need magic to transform our world.", author: "J. K. Rowling" },
        { text: "You miss 100 percent of the shots you don't take.", author: "Wayne Gretzky" },
        { text: "A good hockey player plays where the puck is.", author: "Wayne Gretzky" },
        { text: "I've failed over and over and over again in my life. And that is why I succeed.", author: "Michael Jordan" },
        { text: "Some people want it to happen, some wish it would happen, others make it happen.", author: "Michael Jordan" },
        { text: "You must expect great things of yourself before you can do them.", author: "Michael Jordan" },
        { text: "Don't count the days, make the days count.", author: "Muhammad Ali" },
        { text: "He who is not courageous enough to take risks will accomplish nothing.", author: "Muhammad Ali" },
        { text: "The man who has no imagination has no wings.", author: "Muhammad Ali" },
        { text: "If my mind can conceive it, then I can achieve it.", author: "Muhammad Ali" },
        { text: "Float like a butterfly, sting like a bee.", author: "Muhammad Ali" },
        { text: "Champions keep playing until they get it right.", author: "Billie Jean King" },
        { text: "Pressure is a privilege.", author: "Billie Jean King" },
        { text: "I think self-awareness is probably the most important thing.", author: "Billie Jean King" },
        { text: "The difference between the impossible and the possible lies in determination.", author: "Tommy Lasorda" },
        { text: "The harder the conflict, the greater the triumph.", author: "George Washington" },
        { text: "Perseverance and spirit have done wonders in all ages.", author: "George Washington" },
        { text: "Give me six hours to chop down a tree and I will spend four sharpening the axe.", author: "Abraham Lincoln" },
        { text: "I am a slow walker, but I never walk back.", author: "Abraham Lincoln" },
        { text: "The best way to predict your future is to create it.", author: "Abraham Lincoln" },
        { text: "Whatever you are, be a good one.", author: "Abraham Lincoln" },
        { text: "I walk slowly, but I never walk backward.", author: "Abraham Lincoln" },
        { text: "Every strike brings me closer to the next home run.", author: "Babe Ruth" },
        { text: "It is hard to beat a person who never gives up.", author: "Babe Ruth" },
        { text: "Never let the fear of striking out keep you from playing the game.", author: "Babe Ruth" },
        { text: "Do not wait to strike till the iron is hot; make it hot by striking.", author: "William Butler Yeats" },
        { text: "Education is not the filling of a pail, but the lighting of a fire.", author: "William Butler Yeats" },
        { text: "There are no strangers here; only friends you haven't yet met.", author: "William Butler Yeats" },
        { text: "Think like a wise man but communicate in the language of the people.", author: "William Butler Yeats" },
        { text: "The important thing is not to stop questioning.", author: "Albert Einstein" },
        { text: "Stay hungry, stay foolish.", author: "Steve Jobs" },
        { text: "Innovation distinguishes between a leader and a follower.", author: "Steve Jobs" },
        { text: "The people who are crazy enough to think they can change the world are the ones who do.", author: "Steve Jobs" },
        { text: "Your time is limited, so don't waste it living someone else's life.", author: "Steve Jobs" },
        { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
        { text: "I never dreamed about success. I worked for it.", author: "Estee Lauder" },
        { text: "When you stop talking, you've lost your customer.", author: "Estee Lauder" },
        { text: "I didn't get there by wishing for it, but by working for it.", author: "Estee Lauder" },
        { text: "The most difficult thing is the decision to act, the rest is merely tenacity.", author: "Amelia Earhart" },
        { text: "If you can dream it, you can do it.", author: "Walt Disney" },
        { text: "Whether you think you can or think you can't, you're right.", author: "Henry Ford" },
        { text: "Failure is simply the opportunity to begin again, this time more intelligently.", author: "Henry Ford" },
        { text: "Obstacles are those frightful things you see when you take your eyes off your goal.", author: "Henry Ford" },
        { text: "Nothing is particularly hard if you divide it into small jobs.", author: "Henry Ford" },
        { text: "The only real mistake is the one from which we learn nothing.", author: "Henry Ford" },
        { text: "If there is no struggle, there is no progress.", author: "Frederick Douglass" },
        { text: "The best revenge is massive success.", author: "Frank Sinatra" },
        { text: "You may be disappointed if you fail, but you are doomed if you don't try.", author: "Beverly Sills" },
        { text: "There are no shortcuts to any place worth going.", author: "Beverly Sills" },
        { text: "A goal without a plan is just a wish.", author: "Antoine de Saint-Exupery" },
        { text: "Tell me and I forget. Teach me and I remember. Involve me and I learn.", author: "Benjamin Franklin" },
        { text: "Lost time is never found again.", author: "Benjamin Franklin" },
        { text: "By failing to prepare, you are preparing to fail.", author: "Benjamin Franklin" },
        { text: "Diligence is the mother of good luck.", author: "Benjamin Franklin" },
        { text: "Either write something worth reading or do something worth writing.", author: "Benjamin Franklin" }
      ];
    }
  })();
